export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Get Ready Pack: Dakar 2026",
    "shortTitle": "",
    "description": "",
    "width": 620,
    "height": 877,
    "currentLanguage": "EN",
    "languages": [
      {
        code: "EN",
        text: "English",
        href: "https://getreadypack.olympics.com/dakar2026/en/"
      },
      {
        code: "ES",
        text: "Spanish",
        href: "https://getreadypack.olympics.com/dakar2026/es/"
      },
      {
        code: "FR",
        text: "French",
        href: "https://getreadypack.olympics.com/dakar2026/fr/"
      },
      {
        code: "ZH",
        text: "Chinese",
        href: "https://getreadypack.olympics.com/dakar2026/zh/"
      },
      {
        code: "AR",
        text: "Arabic",
        href: "https://getreadypack.olympics.com/dakar2026/ar/"
      }
    ],
    "basePath": "/dakar2026/en",
    // "basePath": "",
    "companyLogo": "1-logo-1.png",
    "publishURL": "https://getreadypack.olympics.com/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": true,
      "downloadPath": '/dakar2026/en/static/_content/Athlete365_GetReadyPack_Dakar_2026.pdf',
      "printEnabled": false,
      "zoom": {
        "navEnabled": false,
        "sliderEnabled": true,
        "clickEnabled": true,
        "scrollEnabled": true,
      },
      "contents": {
        "enabled": true,
        "pinned": false,
        "numbers": true,
        "titles": true,
      },
      "languagesEnabled": true,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {},
      "fullscreenEnabled": true,
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      <img class="abs halfScale 1-title" style="top:40px;left:463px;" src="/dakar2026/en/static/_content/1-title-1.png"/>
      <img class="abs halfScale 1-title" style="top:170px;left:345px;" src="/dakar2026/en/static/_content/1-title-2.png"/>
      <img class="abs halfScale 1-title" style="top:301px;left:394px;" src="/dakar2026/en/static/_content/1-title-3.png"/>
      <img class="abs halfScale 1-sub" style="top:430px;left:427px;" src="/dakar2026/en/static/_content/1-sub-1.png"/>
      <img class="abs halfScaleC 1-logo" style="top:749px;left:515px;" src="/dakar2026/en/static/_content/1-logo-1.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.staggerFromTo(cOf("1-title"), 0.8, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("1-sub"), 0.7, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(cOf("1-logo"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8);
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "get ready PACK  DAKAR 2026"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 2-title" style="top:76px;left:20px;" src="/dakar2026/en/static/_content/2-title-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(3);" style="top:167px; left:72px; width:208px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(4);" style="top:180px; left:72px; width:208px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(5);" style="top:193px; left:72px; width:208px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(6);" style="top:207px; left:72px; width:208px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(7);" style="top:221px; left:72px; width:208px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(8);" style="top:234px; left:72px; width:208px; height:13px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(10);" style="top:269px; left:72px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(11);" style="top:295px; left:72px; width:198px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(12);" style="top:307px; left:72px; width:198px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(13);" style="top:322px; left:72px; width:198px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(14);" style="top:336px; left:72px; width:198px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(15);" style="top:349px; left:72px; width:198px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(16);" style="top:363px; left:72px; width:198px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(17);" style="top:376px; left:72px; width:198px; height:13px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(18);" style="top:403px; left:72px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(19);" style="top:430px; left:72px; width:160px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(20);" style="top:444px; left:72px; width:160px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(21);" style="top:458px; left:72px; width:160px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(22);" style="top:472px; left:72px; width:160px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(23);" style="top:486px; left:72px; width:160px; height:13px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(24);" style="top:163px; left:371px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(25);" style="top:189px; left:370px; width:138px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(26);" style="top:203px; left:370px; width:138px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(27);" style="top:217px; left:370px; width:138px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(28);" style="top:230px; left:370px; width:138px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(29);" style="top:245px; left:370px; width:138px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(30);" style="top:258px; left:370px; width:138px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(31);" style="top:273px; left:370px; width:138px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(32);" style="top:285px; left:370px; width:138px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(33);" style="top:300px; left:370px; width:138px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(34);" style="top:313px; left:370px; width:138px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(37);" style="top:328px; left:370px; width:138px; height:13px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(38);" style="top:354px; left:371px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(39);" style="top:380px; left:370px; width:148px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(40);" style="top:394px; left:370px; width:148px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(41);" style="top:407px; left:370px; width:148px; height:13px;"></div> 
      <div class="addContentLink" onclick="Publish.goToPage(42);" style="top:421px; left:370px; width:148px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(43);" style="top:435px; left:370px; width:148px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(44);" style="top:448px; left:370px; width:148px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(45);" style="top:462px; left:370px; width:148px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(46);" style="top:476px; left:370px; width:148px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(47);" style="top:491px; left:370px; width:148px; height:13px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(48);" style="top:505px; left:370px; width:148px; height:13px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim.fromTo(cOf("2-title"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);

          setTimeout(function(){
            addContentLinks();
         },1000)
        }

        function onPageLeave() {
          pg2Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Contents  Contents  2  Contents 3 4 5 6 7 8  Start your Olympic journey Athlete365 app Welcome to Dakar 2026 Africa Welcomes, Dakar Celebrates Get to know Senegal Games map  Your YOG essentials 11 Arrivals 12 Accreditation 13 Getting to your competition venue 14 Cluster overview: Dakar 15 Cluster overview: Diamniadio 16 Cluster overview: Saly 17 Ceremonies  Life in the Village 19 Youth Olympic Village map 20 Accommodation 21 Village services 22 Athlete365 House 23 Eating and drinking  Athlete Education Programme 25 Introduction 26 Overview 27 Learning courses 28 PinQuest 29 Integrity 30 Career support 31 Health and well-being 32 Digital and media 33 Olympic Impact 34 Athlete Role Models 37 Inside Sport Sessions  Need to know 39 How to seek help 40 Online abuse protection 41 Mindfulness app 42 Anti-doping 43 Athlete expression 44 Content guidelines 45 How to access tickets 46 Get Set – Train Smarter 47 Sustainability 48 Departures"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 3-title" style="top:76px;left:21px;" src="/dakar2026/en/static/_content/3-title-1.png"/>
      <img class="abs halfScale 3-title" style="top:138px;left:21px;" src="/dakar2026/en/static/_content/3-title-2.png"/>
      <img class="abs halfScale 3-title" style="top:197px;left:21px;" src="/dakar2026/en/static/_content/3-title-3.png"/>
      <img class="abs halfScale 3-title" style="top:274px;left:21px;" src="/dakar2026/en/static/_content/3-sub-1.png"/>

      <img class="abs halfScaleC 3-icon" style="top:426px;left:-25px;" src="/dakar2026/en/static/_content/3-icon-1.png"/>
      <img class="abs halfScaleC 3-icon" style="top:507px;left:-25px;" src="/dakar2026/en/static/_content/3-icon-2.png"/>
      <img class="abs halfScaleC 3-icon" style="top:587px;left:-25px;" src="/dakar2026/en/static/_content/3-icon-3.png"/>
      <img class="abs halfScaleC 3-icon" style="top:667px;left:-25px;" src="/dakar2026/en/static/_content/3-icon-4.png"/>

      <a href="https://www.olympics.com/athlete365/auth/sign-in" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 3-button pointer" style="top:765px;left:22px;" src="/dakar2026/en/static/_content/3-button-1.png"/>
      </a>

      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim.staggerFromTo(cOf("3-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("3-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.7);
        }

        function onPageLeave() {
          pg3Anim.stop();
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Start your Olympic journey  Contents  Start your Olympic journey with Athlete365 Our mission is to make athletes’ lives better. Athlete365 is the global community for athletes and their entourage members. With more than 210,000 members from around the world, we support you with:  Exclusive offers  Practical resources  Learning opportunities  Games-time information  Sign up now  3"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 4-title" style="top:411px;left:20px;" src="/dakar2026/en/static/_content/4-title-1.png"/>
      <img class="abs halfScale 4-title" style="top:472px;left:20px;" src="/dakar2026/en/static/_content/4-title-2.png"/>
      <img class="abs halfScale 4-title" style="top:544px;left:20px;" src="/dakar2026/en/static/_content/4-sub-1.png"/>

      <a href="http://athlete365.org/download" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 4-button pointer" style="top:723px;left:160px;" src="/dakar2026/en/static/_content/4-button-1.png"/>
      </a>

      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim.staggerFromTo(cOf("4-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg4Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete365 app  Download the Athlete365 app Everything that Athlete365 has to offer, right at your fingertips. Your go-to destination for our practical resources, learning opportunities and exclusive offers, the Athlete365 app is split into five sections:  Learning  Home  Your network  The latest news from Athlete365.  For you  Log in to access a personalised feed and track your Athlete365 Learning progress.  Games  Everything you need to know before, during and after your time at Dakar 2026.  Easy access to all of our bespoke educational courses, with insight from experts and Worldwide Olympic Partners.  Keep up to date with the global athlete community and meet your representatives from the IOC Athletes’ Commission.  Download the Athlete365 app now  4"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 5-title" style="top:302px;left:20px;" src="/dakar2026/en/static/_content/5-title-1.png"/>
      <img class="abs halfScale 5-title" style="top:354px;left:23px;" src="/dakar2026/en/static/_content/5-title-2.png"/>
      <img class="abs halfScale 5-title" style="top:417px;left:20px;" src="/dakar2026/en/static/_content/5-sub-1.png"/>

      <img class="abs halfScaleC 5-icon" style="top:106px;left:140px;" src="/dakar2026/en/static/_content/5-icon-1.png"/>

      <img class="abs halfScaleC 5-icon" style="top:484px;left:-17px;" src="/dakar2026/en/static/_content/5-icon-2.png"/>
      <h1 id="5-no" class="abs olympicHeadlineReg 5-no" style="top:514px;left:104px; font-size: 5.1em; font-weight: 300; color: #01287f; padding: 0px; margin: 0px;"  data-number='{"to": 2700, "comma": true}' ></h1>
      <img class="abs halfScale 5-text" style="top:547px;left:261px;" src="/dakar2026/en/static/_content/5-text-1.png"/>

      <img class="abs halfScaleC 5-icon" style="top:592px;left:2px;" src="/dakar2026/en/static/_content/5-icon-3.png"/>
      <h1 id="5-no" class="abs olympicHeadlineReg 5-no" style="top:630px;left:103px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 25}' ></h1>
      <img class="abs halfScale 5-text" style="top:643px;left:139px;" src="/dakar2026/en/static/_content/5-text-2.png"/>

      <img class="abs halfScaleC 5-icon" style="top:592px;left:286px;" src="/dakar2026/en/static/_content/5-icon-4.png"/>
      <h1 id="5-no" class="abs olympicHeadlineReg 5-no" style="top:630px;left:388px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 10}' ></h1>
      <img class="abs halfScale 5-text" style="top:643px;left:419px;" src="/dakar2026/en/static/_content/5-text-3.png"/>

      <h1 id="5-no" class="abs olympicHeadlineReg 5-no" style="top:696px;left:274px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 50, "append" : "/"}' ></h1>
      <h1 id="5-no" class="abs olympicHeadlineReg 5-no" style="top:696px;left:316px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 50}' ></h1>
      <img class="abs halfScale 5-bottom-text" style="top:734px;left:255px;" src="/dakar2026/en/static/_content/5-text-5.png"/>
      <img class="abs halfScale 5-line" style="top:714px;left:163px;" src="/dakar2026/en/static/_content/5-line-1.png"/>
      <img class="abs halfScale 5-line" style="top:714px;left:352px;" src="/dakar2026/en/static/_content/5-line-2.png"/>
      <img class="abs halfScale 5-bottom-icon" style="top:761px;left:20px;" src="/dakar2026/en/static/_content/5-icon-5.png"/>
      <img class="abs halfScale 5-bottom-icon" style="top:761px;left:311px;" src="/dakar2026/en/static/_content/5-icon-6.png"/>
      <img class="abs halfScale 5-bottom-icon" style="top:755px;left:309px;" src="/dakar2026/en/static/_content/5-line-3.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim.staggerFromTo(cOf("5-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("5-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.5)

          .fromTo(cOf("5-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[0])}}, 1.9)
          .staggerFromTo(cOf("5-text"), 0.6, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 2)
          .fromTo(cOf("5-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[1])}}, 2.1)
          .fromTo(cOf("5-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[2])}}, 2.3)

          .fromTo(cOf("5-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[3])}}, 2.8)
          .fromTo(cOf("5-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[4])}}, 2.8)
          .fromTo(cOf("5-bottom-text"), 0.5, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3)
          .fromTo(cOf("5-line"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.2)
          .fromTo(cOf("5-bottom-icon"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.2);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg5Anim.stop();
          resetNumbers("5-no");
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Welcome to Dakar 2026  Contents  5  Welcome to Dakar 2026 Dakar 2026 is the 4th Summer Youth Olympic Games (YOG) – and the first Olympic sporting event to be held in Africa.  2,700 25  athletes  10  competition sports  50/50  full gender equality  engagement sports"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 6-title" style="top:85px;left:20px;" src="/dakar2026/en/static/_content/6-title-1.png"/>
      <img class="abs halfScale 6-title" style="top:136px;left:20px;" src="/dakar2026/en/static/_content/6-title-2.png"/>
      <img class="abs halfScale 6-title" style="top:200px;left:20px;" src="/dakar2026/en/static/_content/6-sub-1.png"/>

      <img class="abs halfScale 6-title" style="top:298px;left:20px;" src="/dakar2026/en/static/_content/6-text-1.png"/>
      <img class="abs halfScale 6-caption" style="top:338px;left:195px;" src="/dakar2026/en/static/_content/6-caption-1.png"/>
      <img class="abs halfScale 6-text" style="top:369px;left:181px;" src="/dakar2026/en/static/_content/6-text-2.png"/>
      <img class="abs halfScale 6-caption" style="top:338px;left:351px;" src="/dakar2026/en/static/_content/6-caption-2.png"/>
      <img class="abs halfScale 6-text" style="top:369px;left:327px;" src="/dakar2026/en/static/_content/6-text-3.png"/>
      <img class="abs halfScale 6-caption" style="top:338px;left:508px;" src="/dakar2026/en/static/_content/6-caption-3.png"/>
      <img class="abs halfScale 6-text" style="top:369px;left:476px;" src="/dakar2026/en/static/_content/6-text-4.png"/>

      <img class="abs halfScaleC 6-icon" style="top:222px;left:167px;" src="/dakar2026/en/static/_content/6-icon-1.png"/>
      <img class="abs halfScaleC 6-icon" style="top:222px;left:317px;" src="/dakar2026/en/static/_content/6-icon-2.png"/>
      <img class="abs halfScaleC 6-icon" style="top:222px;left:468px;" src="/dakar2026/en/static/_content/6-icon-3.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim.staggerFromTo(cOf("6-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("6-caption"), 0.7, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.7)
          .fromTo(cOf("6-text"), 0.7, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)
          .fromTo(cOf("6-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg6Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Africa Welcomes, Dakar Celebrates  6  Africa Welcomes, Dakar Celebrates Dakar 2026 will unite youth and sport, drive the transformation of Senegal, and provide inspiration for all of Africa.  As an athlete at Dakar 2026, you are part of history as you compete in the first Olympic sporting event to be held on African soil – but this Youth Olympic Games is so much more than that.  By the youth, for the youth  Dakar 2026 will give you a platform to shine and provide opportunities for young people in Senegal and across Africa.  A celebration of Africa  Dakar 2026 will highlight the cultural wealth of Senegal and showcase the diversity and potential of Africa to the world.  A catalyst for change  Dakar 2026 will bring lasting economic, social and environmental benefits to the local population."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 7-title" style="top:99px;left:20px;" src="/dakar2026/en/static/_content/7-title-1.png"/>
      <img class="abs halfScale 7-title" style="top:161px;left:20px;" src="/dakar2026/en/static/_content/7-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/app/uploads/2026/NCS-250930-Welcome-to-Dakar-EN.pdf" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 7-button pointer" style="top:775px;left:402px;" src="/dakar2026/en/static/_content/7-button-1.png"/>
      </a>
      
      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.staggerFromTo(cOf("7-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg7Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Get to know Senegal  7  Get to know Senegal From the spirit of ‘Teranga’ to some favourite local dishes, here’s what you can expect from your host country. ‘Teranga’  Senegal is known as the land of Teranga – a word in the local Wolof language that embodies the country’s unique spirit of warmth, respect and hospitality. Teranga is deeply embedded in Senegalese life, reflecting the country’s culture of generosity and openness towards others.  TIP: Always greet people when you arrive somewhere – greetings are very important in Senegalese culture.  Senegalese food  Senegalese cuisine is characterised by flavourful dishes prepared in large portions to be shared with family and friends. It blends local traditions with North African, French and Asian influences. Iconic dishes: • Thiebou djeun – The national dish of Senegal – a one-pot meal made with rice, fish and vegetables in a rich tomato sauce. • Mafé – An iconic West African stew with tender meat and vegetables in a rich peanut sauce. • Yassa – Bone-in chicken marinated in a tangy and spicy lemon sauce. • C’est bon – Grilled fish in a tomato and onion sauce.  FIND OUT MORE about Senegal with our Welcome to Dakar guide.  read the guide"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>

      <img class="abs halfScale 8-title" style="top:68px;left:20px;" src="/dakar2026/en/static/_content/8-title-1.png"/>
      <img class="abs halfScale 8-title" style="top:130px;left:20px;" src="/dakar2026/en/static/_content/8-sub-1.png"/>

      <img class="abs halfScaleC 8-icon" id="pg8Arrow" style="top:112px;left:281px;" src="/dakar2026/en/static/_content/8-icon-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(14);" style="top:344px;left:154px;width:63px;height:27px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(15);" style="top:213px;left:492px;width:83px;height:27px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.staggerFromTo(cOf("8-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("8-icon"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.6);
          setTimeout(function(){
            addContentLinks();
            addPulse("pg8Arrow")
          }, 3000)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg8Anim.stop();
          removeContentLinks();
          removePulse("pg8Arrow")
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Games map  Contents  8  Games map Click on your cluster to find out more.  DiAMNiADiO 2km  AD  7 G  4  7  4 5  5  6 6  Diamniadio TER Station  E A1  DAKAR  C  7 mins  A1 H  H  F  B 20km  1 1 35km  3  4. EQUESTRIAN CENTRE 17 mins  Dakar TER Station  2 2  Equestrian (Jumping)  60 mins  5. DAKAR ARENA  A  7. DAKAR EXPO CENTRE  10 mins  1. COMPLEXE TOUR DE L'OEUF 90 mins  Swimming 106 3×3mins Basketball  Breaking 1. COMPLEXE TOUR DE L'OEUF  Baseball5 Swimming Skateboarding (Street) 3×3 Basketball  Breaking Baseball5 IBA MAR DIOP 2. COMPLEXE Skateboarding (Street) 75 mins Rugby Sevens Athletics Taekwondo Futsal 87 mins  MAIN HOSPiTAL OF DAKAR 2. A. COMPLEXE IBA MAR DIOP 125 mins  10 mins  Badminton  Fencing  Futsal  3. CORNiCHE WEST  Boxing Table Tennis  110 mins  6. ABDOULAYE WADE STADIUM  Cycling Road  Wushu (Taolu) Artistic Gymnastics 5 mins  5 mins  Engagement sports  Judo  Archery  Weightlifting Tennis  Archery Intl’ Broadcast Centre Cycling Road  Opening Ceremony  Karate Shooting  YOV  Surfing  E. MAiN LOGiSTiCS HUB  26 mins  Athletics (track)  14 mins  Futsal  7 mins  4. CENTRE EQUESTRE 3×3 Basketball F. UNiFORM AND Equestrian (Jumping) Baseball5 ACCREDiTATiON CENTRE  Sport Climbing Hockey Golf Modern Pentathlon  Rugby Sevens  Canoe  ENGAGEMENT SPORTS*  *Locations to be confirmed  Taekwondo  G. CICAD  Triathlon (running)  Main Press Centre  10 mins  Weightlifting  Sport Climbing  Closing Ceremony  Rugby Sevens  Tennis  Hockey  19 mins D. THE GROUND 14 mins 5. DAKAR ARENA  B. MiLiTARY HOSPiTAL OF OUAKAM Athletics 125 mins  Karate  Golf  Boxing  Shooting  Modern Pentathlon  125 mins Futsal  Surfing  Canoe  C. DAKAR 2026 HEADQUARTERS Main Operations Centre Technology Operations Centre  6. STADE ABDOULAYE WADE  Swimming Boxing  H. YOG HOSPITAL 19 mins  Gymnastics  Badminton Artistic Gymnastics Triathlon (swimming)  19 mins  7. DAKAR EXPO CENTRE Fencing Taekwondo Table Tennis Wushu (Taolu) Artistic Gymnastics Judo"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <div class="addContentLink" onclick="Publish.goToPage(16);" style="top:700px;left:249px;width:46px;height:26px;border-radius:0px;"></div>

      `,
      "script": `
        function onPageEnter() {
        setTimeout(function(){
            addContentLinks();
          },3000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "High  Get Ready Pack: Dakar 2026 | Games map  Contents  9  DAKAR 2026 MASTER PLAN X X X  Competition Venues  X X X  NON-Comp Venues Competition  way  A1 Airport TER Station  Training Engagement Sports  Blaise Diagne International Airport  Youth Olympic Village  35 mins  H A1  35 mins  igh  Blaise Diagne International Airport  y wa  A1 Highway Train Express Régional (TER) TER Stations Shuttle  20km  Travel time from YOV  35km  A1  ATLANTIC OCEAN  56 mins  8. SALY BEACH WEST 8. SALY PLAGE OUEST 55 mins  8 8  SALY  Sailing (Windsurfing)  Rowing Coastal Beach Sailing (Windsurfing) Sprints Rowing Coastal  Beach Volleyball Beach Sprints Beach Volleyball Beach Handball  Beach Handball Beach Wrestling Beach Wrestling Triathlon Triathlon  50km"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 10-title" style="top:206px;left:217px;" src="/dakar2026/en/static/_content/10-title-1.png"/>
      <img class="abs halfScale 10-title" style="top:288px;left:220px;" src="/dakar2026/en/static/_content/10-title-2.png"/>
      <img class="abs halfScale 10-title" style="top:380px;left:220px;" src="/dakar2026/en/static/_content/10-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(11);" style="top:480px; left:216px; width:296px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(12);" style="top:513px; left:216px; width:296px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(13);" style="top:546px; left:216px; width:296px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(14);" style="top:580px; left:216px; width:296px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(15);" style="top:614px; left:216px; width:296px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(16);" style="top:648px; left:216px; width:296px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(17);" style="top:680px; left:216px; width:296px; height:22px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim.staggerFromTo(cOf("10-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg10Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Your YOG essentials  YOUR YOG ESSENTIALS Navigate the Games with confidence.  11  Arrivals  12  Accreditation  13  Getting to your competition venue  14  Cluster overview: Dakar  15  Cluster overview: Diamniadio  16  Cluster overview: Saly  17  Ceremonies  10"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 11-title" style="top:501px;left:21px;" src="/dakar2026/en/static/_content/11-title-1.png"/>
      <img class="abs halfScale 11-title" style="top:565px;left:21px;" src="/dakar2026/en/static/_content/11-sub-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim.staggerFromTo(cOf("11-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg11Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Arrivals  11  Arrivals What to expect when you arrive in Senegal.  1  When you arrive at the airport, your NOC will accompany you through immigration and baggage claim.  2 You will then go to the transport zone, where you will board a bus to the Youth Olympic Village. arrival at the Youth Olympic Village, you will go through a security check and your baggage will 3 On be taken to a storage area.  4 You will then pick up your accreditation – more information on the next page. 5 When you have your accreditation, staff will direct you to your accommodation. your yog essentials"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 12-title" style="top:100px;left:21px;" src="/dakar2026/en/static/_content/12-title-1.png"/>
      <img class="abs halfScale 12-title" style="top:163px;left:21px;" src="/dakar2026/en/static/_content/12-sub-1.png"/>

      <img class="abs halfScaleC 12-icon" style="top:179px;left:16px;" src="/dakar2026/en/static/_content/12-icon-1.png"/>
      <img class="abs halfScale 12-caption" style="top:343px;left:38px;" src="/dakar2026/en/static/_content/12-caption-1.png"/>
      <img class="abs halfScale 12-line" style="top:220px;left:210px;" src="/dakar2026/en/static/_content/12-line.png"/>

      <img class="abs halfScaleC 12-icon" style="top:179px;left:216px;" src="/dakar2026/en/static/_content/12-icon-2.png"/>
      <img class="abs halfScale 12-caption" style="top:343px;left:236px;" src="/dakar2026/en/static/_content/12-caption-2.png"/>
      <img class="abs halfScale 12-line" style="top:220px;left:410px;" src="/dakar2026/en/static/_content/12-line.png"/>

      <img class="abs halfScaleC 12-icon" style="top:179px;left:416px;" src="/dakar2026/en/static/_content/12-icon-3.png"/>
      <img class="abs halfScale 12-caption" style="top:343px;left:435px;" src="/dakar2026/en/static/_content/12-caption-3.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim.staggerFromTo(cOf("12-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)

          .staggerFromTo(cOf("12-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)
          .staggerFromTo(cOf("12-caption"), 0.8, {opacity:0, y: 25}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.5)
          .staggerFromTo(cOf("12-line"), 0.8, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.6);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg12Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Accreditation  Contents  12  Accreditation Everything you need to know about your accreditation and how to keep it safe. For more information, please contact your NOC.  1  2  3  When you arrive at the Youth Olympic Village, you will be taken to pick up your Youth Olympic Accreditation Card (YOAC).  At the Accreditation Centre, present your passport and visa (if applicable) to collect your YOAC.  Your YOAC is your official accreditation, granting you access to the venues and services you need. You must carry it with you at all times, apart from training or competition.  TIP: Hang your accreditation on the inside door handle of your room before you go to bed. Then, when you leave your room, you’ll be reminded to put it on.  your yog essentials"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 13-title" style="top:100px;left:21px;" src="/dakar2026/en/static/_content/13-title-1.png"/>
      <img class="abs halfScale 13-title" style="top:150px;left:21px;" src="/dakar2026/en/static/_content/13-title-2.png"/>
      <img class="abs halfScale 13-title" style="top:214px;left:21px;" src="/dakar2026/en/static/_content/13-sub-1.png"/>
   
      <img class="abs halfScale 13-dakar" style="top:209px;left:341px;" src="/dakar2026/en/static/_content/13-dakar.png"/>
      <img class="abs halfScaleC 13-icon" style="top:236px;left:248px;" src="/dakar2026/en/static/_content/13-dakar-icon-group-1.png"/>
      <img class="abs halfScaleC 13-icon" style="top:315px;left:248px;" src="/dakar2026/en/static/_content/13-dakar-icon-group-2.png"/>
      <img class="abs halfScaleC 13-icon" style="top:409px;left:248px;" src="/dakar2026/en/static/_content/13-dakar-icon-group-3.png"/>
      <img class="abs halfScale 13-dakar-text" style="top:282px;left:402px;" src="/dakar2026/en/static/_content/13-dakar-text-1.png"/>
      <img class="abs halfScale 13-dakar-text" style="top:356px;left:402px;" src="/dakar2026/en/static/_content/13-dakar-text-2.png"/>
      <img class="abs halfScale 13-dakar-text" style="top:454px;left:402px;" src="/dakar2026/en/static/_content/13-dakar-text-3.png"/>

      <img class="abs halfScale 13-saly" style="top:571px;left:411px;" src="/dakar2026/en/static/_content/13-saly.png"/>
      <img class="abs halfScaleC 13-icon" style="top:540px;left:450px;" src="/dakar2026/en/static/_content/13-saly-icon-group-1.png"/>
      <img class="abs halfScaleC 13-saly-text" style="top:662px;left:415px;" src="/dakar2026/en/static/_content/13-saly-text-1.png"/>

      <img class="abs halfScale 13-diamniadio" style="top:447px;left:120px;" src="/dakar2026/en/static/_content/13-diamniadio.png"/>

      <img class="abs halfScaleC 13-diamniadio-text" style="top:503px;left:147px;" src="/dakar2026/en/static/_content/13-diamniadio-text-1.png"/>
      <img class="abs halfScaleC 13-diamniadio-text" style="top:556px;left:175px;" src="/dakar2026/en/static/_content/13-diamniadio-text-2.png"/>
      <img class="abs halfScaleC 13-diamniadio-text" style="top:658px;left:169px;" src="/dakar2026/en/static/_content/13-diamniadio-text-3.png"/>
      <img class="abs halfScaleC 13-diamniadio-text" style="top:741px;left:146px;" src="/dakar2026/en/static/_content/13-diamniadio-text-4.png"/>
      <img class="abs halfScaleC 13-icon" style="top:500px;left:212px;" src="/dakar2026/en/static/_content/13-diamniadio-icon-group-1.png"/> 
      <img class="abs halfScaleC 13-icon" style="top:554px;left:212px;" src="/dakar2026/en/static/_content/13-diamniadio-icon-group-2.png"/>
      <img class="abs halfScaleC 13-icon" style="top:656px;left:212px;" src="/dakar2026/en/static/_content/13-diamniadio-icon-group-3.png"/>
      <img class="abs halfScaleC 13-icon" style="top:744px;left:212px;" src="/dakar2026/en/static/_content/13-diamniadio-icon-group-4.png"/>

      <img class="abs halfScaleC 13-icon-big" style="top:555px;left:283px;" src="/dakar2026/en/static/_content/13-icon-1.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim.staggerFromTo(cOf("13-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("13-icon-big"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.7)
          .fromTo(cOf("13-dakar"), 0.8, {opacity:0, y: -15}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2)
          .fromTo(cOf("13-saly"), 0.8, {opacity:0, x: 15}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2)
          .fromTo(cOf("13-diamniadio"), 0.8, {opacity:0, x: -15}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2)
          .staggerFromTo(cOf("13-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 2.2)
          .staggerFromTo(cOf("13-dakar-text"), 0.8, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2.4)
          .staggerFromTo(cOf("13-saly-text"), 0.8, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2.4)
          .staggerFromTo(cOf("13-diamniadio-text"), 0.8, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2.4);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg13Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Getting to your competition venue  Contents  13  Getting to your competition venue Average travel time between the Village and each competition venue. The transport system at Dakar 2026 is made up of trains and buses. When travelling between the Youth Olympic Village and your competition or training venues, you should be accompanied at all times by someone from your NOC.  Equestrian (EQU)  Badminton (BDM) Futsal (FBS)  110 min  DAR  10 min  Boxing (BOX) Fencing (FEN) Artistic Gymnastics (GAR)  Judo (JUD) Table Tennis (TTE)  DEX  Dakar Expo Centre  10 min  Wushu (WST) Opening Ceremony Archery (ARC)  your yog essentials  SAW  Abdoulaye Wade Stadium  Cycling Road (CRD)  COR  Corniche West  5 min  Basket 3x3 (BK3)  CTO  90 min  17 min  Dakar Arena  Walk  Baseball 5 (BS5)  CED  Equestrian Centre  Train  DAKAR  Breaking (BKG)  Complexe Tour de l'Oeuf  75 min  DIAMNIADIO  Bus  Skateboarding (SKB) Swimming (SWM)  Athletics (ATH)  CID  Rugby 7 (RU7)  Complexe Iba Mar Diop  Taekwondo (TKW) Futsal (FBS)  56 min  YOUTH OLYMPIC VILLAGE  SALY  SBW  Saly Beach West  Beach Handball (HBB)  Triathlon (TRI)  Beach Volleyball (VBV)  Sailing (SAL)  Beach Wrestling (WRB)  Rowing (RCB)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 14-title" style="top:80px;left:21px;" src="/dakar2026/en/static/_content/14-sub-1.png"/>
      <img class="abs halfScale 14-title" style="top:102px;left:21px;" src="/dakar2026/en/static/_content/14-title-1.png"/>
      <img class="abs halfScale 14-title" style="top:163px;left:21px;" src="/dakar2026/en/static/_content/14-sub-2.png"/>

      <img class="abs halfScale 14-box" style="top:224px;left:21px;" src="/dakar2026/en/static/_content/14-box-1.png"/>
      <img class="abs halfScale 14-box" style="top:426px;left:21px;" src="/dakar2026/en/static/_content/14-box-2.png"/>
      <img class="abs halfScale 14-box" style="top:628px;left:21px;" src="/dakar2026/en/static/_content/14-box-3.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim.staggerFromTo(cOf("14-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("14-box"), 0.8, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.7);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg14Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Cluster overview: Dakar  Contents  14  Cluster overview:  Dakar Dakar will host major and urban sports in iconic venues located in the heart of the city.  Complexe Tour de l’Oeuf Located in the heart of lively and vibrant neighbourhood Point E, Complexe Tour de l’Oeuf will be a central hub for competitions as well as cultural and festive experiences.  Complexe Iba Mar Diop A historic venue that hosted the 1st African Athletics Championships in 1979, Complexe Iba Mar Diop has been transformed for Dakar 2026.  Corniche West An iconic road along the Dakar seashore that will host the road cycling competition and engagement sports activities.  your yog essentials  Sports 3x3 basketball  Baseball5  Swimming  Skateboarding (street)  Breaking  Services Athlete dining with buffet-style meal service  Athletes’ Lounge with drinks and light refreshments  Sports Rugby sevens  Futsal  (group stage)  Athletics  Taekwondo  Services Athlete dining with buffet-style meal service  Sports Cycling road  Services Athletes’ Lounge with drinks and light refreshments  Athletes’ Lounge with drinks and light refreshments"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 15-title" style="top:78px;left:21px;" src="/dakar2026/en/static/_content/15-sub-1.png"/>
      <img class="abs halfScale 15-title" style="top:98px;left:21px;" src="/dakar2026/en/static/_content/15-title-1.png"/>
      <img class="abs halfScale 15-title" style="top:161px;left:21px;" src="/dakar2026/en/static/_content/15-sub-2.png"/>

      <img class="abs halfScale 15-box" style="top:224px;left:21px;" src="/dakar2026/en/static/_content/15-box-1.png"/>
      <img class="abs halfScale 15-box" style="top:374px;left:21px;" src="/dakar2026/en/static/_content/15-box-2.png"/>
      <img class="abs halfScale 15-box" style="top:528px;left:21px;" src="/dakar2026/en/static/_content/15-box-3.png"/>
      <img class="abs halfScale 15-box" style="top:684px;left:21px;" src="/dakar2026/en/static/_content/15-box-4.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim.staggerFromTo(cOf("15-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("15-box"), 0.8, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.7);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg15Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Cluster overview: Diamniadio  Contents  15  Cluster overview:  Diamniadio Diamniadio is the home of the Youth Olympic Village and the majority of indoor venues.  Dakar Expo Centre A modern exhibition complex with six halls hosting six sports.  Dakar Arena  Sports Artistic gymnastics  Boxing  Fencing  Judo  Table tennis  Wushu  Sports Badminton  An indoor sports venue offering a world-class stage for athletes and spectators.  Equestrian Centre A brand-new venue equipped with top-tier facilities and grandstands for more than 1,200 spectators.  Abdoulaye Wade Stadium Dakar’s landmark sports venue and the home of the Senegal national football team.  your yog essentials  Services  Sports  Athletes’ Lounge with drinks and light refreshments  Services Athletes’ Lounge with drinks and light refreshments  Futsal  (final group games, semi-finals, finals)  Services Athletes’ Lounge with drinks and light refreshments  Equestrian (jumping)  Sports Archery  Services Athletes’ Lounge with drinks and light refreshments"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 16-title" style="top:80px;left:21px;" src="/dakar2026/en/static/_content/16-sub-1.png"/>
      <img class="abs halfScale 16-title" style="top:100px;left:21px;" src="/dakar2026/en/static/_content/16-title-1.png"/>
      <img class="abs halfScale 16-title" style="top:161px;left:21px;" src="/dakar2026/en/static/_content/16-sub-2.png"/>

      <img class="abs halfScale 16-box" style="top:224px;left:21px;" src="/dakar2026/en/static/_content/16-box-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim.staggerFromTo(cOf("16-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("16-box"), 0.8, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.7);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg16Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Cluster overview: Saly  Contents  16  Cluster overview:  Saly  With its unique seaside setting, Saly is dedicated to beach and water sports.  Saly Beach West Saly Beach West is an internationally renowned seaside destination that will be transformed into a dynamic hub for sport, culture and celebration.  your yog essentials  Sports Beach handball  Beach volleyball  Beach wrestling  Rowing Sailing coastal beach (windsurfing) sprints  Triathlon  Services Athlete dining with buffet-style meal service  Athletes’ Lounge with drinks and light refreshments"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 17-title" style="top:100px;left:21px;" src="/dakar2026/en/static/_content/17-title-1.png"/>
      <img class="abs halfScale 17-title" style="top:161px;left:21px;" src="/dakar2026/en/static/_content/17-sub-1.png"/>

      <img class="abs halfScale 17-box" style="top:239px;left:20px;" src="/dakar2026/en/static/_content/17-box-1.png"/>
      <img class="abs halfScale 17-box" style="top:271px;left:66px;" src="/dakar2026/en/static/_content/17-caption-1.png"/>
      <img class="abs halfScale 17-box" style="top:334px;left:37px;" src="/dakar2026/en/static/_content/17-text-1.png"/>
      <img class="abs halfScale 17-box" style="top:431px;left:35px;" src="/dakar2026/en/static/_content/17-text-2.png"/>
      <img class="abs halfScaleC 17-box-icon" style="top:506px;left:58px;" src="/dakar2026/en/static/_content/17-icon-date.png"/>
      <img class="abs halfScale 17-box" style="top:598px;left:62px;" src="/dakar2026/en/static/_content/17-icon-text-1.png"/>
      <img class="abs halfScaleC 17-box-icon" style="top:634px;left:58px;" src="/dakar2026/en/static/_content/17-icon-location.png"/>
      <img class="abs halfScale 17-box" style="top:724px;left:49px;" src="/dakar2026/en/static/_content/17-icon-text-2.png"/>

      <img class="abs halfScale 17-box" style="top:239px;left:219px;" src="/dakar2026/en/static/_content/17-box-2.png"/>
      <img class="abs halfScale 17-box" style="top:271px;left:262px;" src="/dakar2026/en/static/_content/17-caption-2.png"/>
      <img class="abs halfScale 17-box" style="top:334px;left:236px;" src="/dakar2026/en/static/_content/17-text-3.png"/>
      <img class="abs halfScale 17-box" style="top:431px;left:237px;" src="/dakar2026/en/static/_content/17-text-4.png"/>
      <img class="abs halfScaleC 17-box-icon" style="top:506px;left:259px;" src="/dakar2026/en/static/_content/17-icon-date.png"/>
      <img class="abs halfScale 17-box" style="top:598px;left:258px;" src="/dakar2026/en/static/_content/17-icon-text-3.png"/>
      <img class="abs halfScaleC 17-box-icon" style="top:634px;left:259px;" src="/dakar2026/en/static/_content/17-icon-location.png"/>
      <img class="abs halfScale 17-box" style="top:724px;left:233px;" src="/dakar2026/en/static/_content/17-icon-text-4.png"/>

      <img class="abs halfScale 17-box" style="top:239px;left:417px;" src="/dakar2026/en/static/_content/17-box-3.png"/>
      <img class="abs halfScale 17-box" style="top:271px;left:461px;" src="/dakar2026/en/static/_content/17-caption-3.png"/>
      <img class="abs halfScale 17-box" style="top:334px;left:436px;" src="/dakar2026/en/static/_content/17-text-5.png"/>
      <img class="abs halfScale 17-box" style="top:400px;left:435px;" src="/dakar2026/en/static/_content/17-text-6.png"/>
      <img class="abs halfScaleC 17-box-icon" style="top:506px;left:455px;" src="/dakar2026/en/static/_content/17-icon-date.png"/>
      <img class="abs halfScale 17-box" style="top:598px;left:459px;" src="/dakar2026/en/static/_content/17-icon-text-5.png"/>
      <img class="abs halfScaleC 17-box-icon" style="top:634px;left:455px;" src="/dakar2026/en/static/_content/17-icon-location.png"/>
      <img class="abs halfScale 17-box" style="top:724px;left:446px;" src="/dakar2026/en/static/_content/17-icon-text-6.png"/>
  
      <img class="abs halfScaleC 17-image" style="top:-56px;left:181px;" src="/dakar2026/en/static/_content/17-image-1.png"/>
      <img class="abs halfScaleC 17-image" style="top:-2px;left:420px;" src="/dakar2026/en/static/_content/17-image-2.png"/>

      <img class="abs halfScale 17-bottom-bar" style="top:835px;left:0px;" src="/dakar2026/en/static/_content/17-bottom-bar-1.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim.staggerFromTo(cOf("17-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("17-image"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4)
          .staggerFromTo(cOf("17-box"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1.6)
          .staggerFromTo(cOf("17-box-icon"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 2.5);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg17Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Ceremonies  Contents  17  Ceremonies Everything you need to know about the Opening and Closing Ceremonies.  Welcome Session  Opening Ceremony  Closing Ceremony  The Welcome Session is an opportunity to get together with all the other athletes at the start of the Games.  One of the most iconic moments of any Games, the Opening Ceremony is the official starting point of Dakar 2026.  The Closing Ceremony is held to mark the official ending of the Games.  You will get a sneak peak of what to expect during Dakar 2026 and be treated to Senegalese artistic and musical performances.  All athletes are invited to take part in the ceremony and the athletes’ parade.  If you’re still in Dakar, all athletes are invited to take part in the ceremony and the Farewell Party that follows.  When is it?  When is it?  When is it?  30 October, time TBC.  31 October at 6:30 p.m.  13 November at 6 p.m.  Where is it?  Where is it?  Where is it?  Youth Olympic Village Plaza.  Abdoulaye Wade Stadium, located just 800m from the Village.  Youth Olympic Village Plaza.  your yog essentials"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>

      <img class="abs halfScale 18-title" style="top:207px;left:219px;" src="/dakar2026/en/static/_content/18-title-1.png"/>
      <img class="abs halfScale 18-title" style="top:288px;left:219px;" src="/dakar2026/en/static/_content/18-title-2.png"/>
      <img class="abs halfScale 18-title" style="top:381px;left:219px;" src="/dakar2026/en/static/_content/18-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(19);" style="top:480px; left:216px; width:236px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(20);" style="top:513px; left:216px; width:236px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(21);" style="top:546px; left:216px; width:236px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(22);" style="top:580px; left:216px; width:236px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(23);" style="top:614px; left:216px; width:236px; height:22px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim.staggerFromTo(cOf("18-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg18Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Life in the Village  life in the village Get to know your home away from home. 19  Youth Olympic Village map  20  Accommodation  21  Village services  22  Athlete365 House  23  Eating and drinking  18"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 19-title" style="top:87px;left:21px;" src="/dakar2026/en/static/_content/19-title-1.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax();
          pg19Anim.fromTo(cOf("19-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg19Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Training Area  Legend Team Processing Center  Training Area  Multifunction Building  Village Plaza  Transport Mall  Residental Buildings  Workforce/Supply Chain  Fitness Center  Dining Hall  Polyclinic  Meeting Hall  Operation Building  PSA  VSA  Security perimeter  VSA Vehicule Screen Area  Residental zone  PSA Pedestrian Screen Area  PSA VSA  services and operations Resident Center Concessions Merchandising Laundry Sport Athlete Education Programme Accreditation Check Equipment Storage Multifaith Room Lost & Found Guest Pass Center NOC Services Center  LIFE IN THE VILLAGE  PSA  LEGEND  Team Processing Center  Residential Buildings  Village Plaza  Transport Mall  Fitness Center  Polyclinic  Operation Building  VSA Vehicule screen area  PSA Pedestrian screen area  ACCREDITATION CHECK  EQUIPEMENT STORAGE  MULTIFAITH ROOM  LOST & FOUND  GUEST PASS CENTER  NOC SERVICES CENTER  Youth Olympic Village Map  Multifunction Building  Workforce / Supply Chain  Dining Hall  Meeting Hall  Security perimeter  Residential zone  RESIDENT CENTER  CONCESSIONS  MERCHANDISING  LAUNDRY  SPORT  ATHLETE EDUCATION PROGRAM  SERVICES AND OPERATIONS  Get Ready Pack: Dakar 2026 | Youth Olympic Village map  Contents  19"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 20-title" style="top:99px;left:21px;" src="/dakar2026/en/static/_content/20-title-1.png"/>
      <img class="abs halfScale 20-title" style="top:161px;left:21px;" src="/dakar2026/en/static/_content/20-sub-1.png"/>
      
      <img class="abs halfScaleC 20-icon" style="top:372px;left:-4px;" src="/dakar2026/en/static/_content/20-icon-1.png"/>
      <img class="abs halfScale 20-caption" style="top:416px;left:78px;" src="/dakar2026/en/static/_content/20-caption-1.png"/>
      <img class="abs halfScaleC 20-icon" style="top:433px;left:-4px;" src="/dakar2026/en/static/_content/20-icon-2.png"/>
      <img class="abs halfScale 20-caption" style="top:475px;left:78px;" src="/dakar2026/en/static/_content/20-caption-2.png"/>
      <img class="abs halfScaleC 20-icon" style="top:492px;left:-4px;" src="/dakar2026/en/static/_content/20-icon-3.png"/>
      <img class="abs halfScale 20-caption" style="top:534px;left:78px;" src="/dakar2026/en/static/_content/20-caption-3.png"/>
      <img class="abs halfScaleC 20-icon" style="top:548px;left:-4px;" src="/dakar2026/en/static/_content/20-icon-4.png"/>
      <img class="abs halfScale 20-caption" style="top:592px;left:78px;" src="/dakar2026/en/static/_content/20-caption-4.png"/>
      <img class="abs halfScaleC 20-icon" style="top:605px;left:-4px;" src="/dakar2026/en/static/_content/20-icon-5.png"/>
      <img class="abs halfScale 20-caption" style="top:651px;left:78px;" src="/dakar2026/en/static/_content/20-caption-5.png"/>
      <img class="abs halfScaleC 20-icon" style="top:665px;left:-4px;" src="/dakar2026/en/static/_content/20-icon-6.png"/>
      <img class="abs halfScale 20-caption" style="top:708px;left:78px;" src="/dakar2026/en/static/_content/20-caption-6.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim.staggerFromTo(cOf("20-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("20-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)
          .staggerFromTo(cOf("20-caption"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.5);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg20Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Accommodation  Contents  Accommodation What to expect in your room in the Youth Olympic Village. All athletes at Dakar 2026 will be staying in the Youth Olympic Village, your home for the duration of the Games. The Village is one of the most unique experiences of any Games, giving you the chance to meet athletes from all over the world and make friends for life.  Your room  When you get to the Village, have gone through security and picked up your accreditation, you will be taken to your room, where you will stay for your time at the Games. Each room will have up to 4 beds, and each resident will have: 1 bath towel  1 hand towel  1 wardrobe  5 hangers  2 laundry bags  1 fan Shared bathrooms will be available on your floor.  LIFE IN THE VILLAGE  20"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 21-title" style="top:99px;left:21px;" src="/dakar2026/en/static/_content/21-title-1.png"/>
      <img class="abs halfScale 21-title" style="top:150px;left:21px;" src="/dakar2026/en/static/_content/21-title-2.png"/>
      <img class="abs halfScale 21-title" style="top:202px;left:21px;" src="/dakar2026/en/static/_content/21-title-3.png"/>
      <img class="abs halfScale 21-title" style="top:254px;left:21px;" src="/dakar2026/en/static/_content/21-title-4.png"/>
      <img class="abs halfScale 21-title" style="top:317px;left:20px;" src="/dakar2026/en/static/_content/21-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/articles/dakar-2026/dakar-2026-youth-olympic-village-services" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 47-btn pointer" style="top:354px;left:-43px;" src="/dakar2026/en/static/_content/21-button-1.png"/>
      </a>
      
      <img class="abs halfScale 21-box" style="top:97px;left:268px;" src="/dakar2026/en/static/_content/21-box-1.png"/>
      <img class="abs halfScale 21-bottom-bar" style="top:836px;left:0px;" src="/dakar2026/en/static/_content/21-bottom-bar-1.png"/>
      <img class="abs halfScale 21-image" style="top:443px;left:148px;" src="/dakar2026/en/static/_content/21-image-1.png"/>

      <img class="abs halfScaleC 21-icon" style="top:92px;left:264px;" src="/dakar2026/en/static/_content/21-icon-1.png" />
      <img class="abs halfScaleC 21-icon" style="top:192px;left:264px;" src="/dakar2026/en/static/_content/21-icon-2.png" />
      <img class="abs halfScaleC 21-icon" style="top:294px;left:264px;" src="/dakar2026/en/static/_content/21-icon-3.png" />
      <img class="abs halfScaleC 21-icon" style="top:398px;left:264px;" src="/dakar2026/en/static/_content/21-icon-4.png" />
      <img class="abs halfScaleC 21-icon" style="top:499px;left:264px;" src="/dakar2026/en/static/_content/21-icon-5.png" />
      <img class="abs halfScaleC 21-icon" style="top:600px;left:264px;" src="/dakar2026/en/static/_content/21-icon-6.png" />
      <img class="abs halfScaleC 21-icon" style="top:704px;left:264px;" src="/dakar2026/en/static/_content/21-icon-7.png" />

      <img class="abs halfScale 21-text" style="top:133px;left:392px;" src="/dakar2026/en/static/_content/21-caption-1.png"/>
      <img class="abs halfScale 21-text" style="top:149px;left:392px;" src="/dakar2026/en/static/_content/21-text-1.png"/>
      <img class="abs halfScale 21-text" style="top:241px;left:392px;" src="/dakar2026/en/static/_content/21-caption-2.png"/>
      <img class="abs halfScale 21-text" style="top:258px;left:392px;" src="/dakar2026/en/static/_content/21-text-2.png"/>
      <img class="abs halfScale 21-text" style="top:337px;left:392px;" src="/dakar2026/en/static/_content/21-caption-3.png"/>
      <img class="abs halfScale 21-text" style="top:354px;left:392px;" src="/dakar2026/en/static/_content/21-text-3.png"/>
      <img class="abs halfScale 21-text" style="top:446px;left:392px;" src="/dakar2026/en/static/_content/21-caption-4.png"/>
      <img class="abs halfScale 21-text" style="top:462px;left:392px;" src="/dakar2026/en/static/_content/21-text-4.png"/>
      <img class="abs halfScale 21-text" style="top:554px;left:392px;" src="/dakar2026/en/static/_content/21-caption-5.png"/>
      <img class="abs halfScale 21-text" style="top:571px;left:392px;" src="/dakar2026/en/static/_content/21-text-5.png"/>
      <img class="abs halfScale 21-text" style="top:663px;left:392px;" src="/dakar2026/en/static/_content/21-caption-6.png"/>
      <img class="abs halfScale 21-text" style="top:680px;left:392px;" src="/dakar2026/en/static/_content/21-text-6.png"/>
      <img class="abs halfScale 21-text" style="top:758px;left:392px;" src="/dakar2026/en/static/_content/21-caption-7.png"/>
      <img class="abs halfScale 21-text" style="top:775px;left:392px;" src="/dakar2026/en/static/_content/21-text-7.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim.staggerFromTo(cOf("21-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("21-box"), 1, {opacity:0, x: 120}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
          .fromTo(cOf("21-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .staggerFromTo(cOf("21-icon"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.8)
          .staggerFromTo(cOf("21-text"), 0.6, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.7);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg21Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Youth Olympic Village services Here’s what you will find in the Youth Olympic Village.  FIND OUT MORE  Get Ready Pack: Dakar 2026 | Youth Olympic Village services  Polyclinic  Medical clinic with a range of services including emergency care, physiotherapy, basic dental, pharmacy and counselling. There is also a first-aid station located in the Village Plaza.  Fitness Centre  Gym with areas for weight training, cardio, stretching and mobility, cross-training and recovery.  Laundry  Self-service laundry facilities with washing machines and dryers. Detergent will be provided and volunteers will be on hand to assist you if needed.  Resident Centre  Get assistance with any accommodation issues, including housekeeping requests, emergency maintenance and lost property.  village plaza  A central space to relax and meet others, with cultural activities and entertainment.  Multifaith room  A quiet space for meditation and worship.  Common areas  Air-conditioned reading room and games room.  LIFE IN THE VILLAGE  21"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 22-title" style="top:326px;left:21px;" src="/dakar2026/en/static/_content/22-title-1.png"/>
      <img class="abs halfScale 22-title" style="top:379px;left:23px;" src="/dakar2026/en/static/_content/22-title-2.png"/>
      <img class="abs halfScale 22-title" style="top:441px;left:20px;" src="/dakar2026/en/static/_content/22-sub-1.png"/>

      <img class="abs halfScale halfpulse 22-box" style="top:325px;left:269px;" src="/dakar2026/en/static/_content/22-box-1.png"/>
      <img class="abs halfScaleC 22-icon" style="top:321px;left:249px;" src="/dakar2026/en/static/_content/22-icon-1.png"/>
      <img class="abs halfScale 22-caption" style="top:352px;left:348px;" src="/dakar2026/en/static/_content/22-caption-1.png"/>
      <img class="abs halfScale 22-caption" style="top:389px;left:348px;" src="/dakar2026/en/static/_content/22-text-1.png"/>

      <div class="abs" style="top:448px;left:294px;height:50px;width:215px;overflow:hidden;">
        <div class="abs pointer" onclick="Publish.goToPage(24);" style="top:-5px;left:-14px;width:232px;height:56px;">
          <img class="abs halfScaleC 22-button" id="button" style="top:-8px;left:7px;" src="/dakar2026/en/static/_content/22-button-1.png"/>
        </div>
      </div>

      <img class="abs halfScaleC 22-icon" style="top:497px;left:242px;" src="/dakar2026/en/static/_content/22-icon-2.png"/>
      <img class="abs halfScaleC 22-icon" style="top:567px;left:242px;" src="/dakar2026/en/static/_content/22-icon-3.png"/>
      <img class="abs halfScaleC 22-icon" style="top:634px;left:242px;" src="/dakar2026/en/static/_content/22-icon-4.png"/>
      <img class="abs halfScaleC 22-icon" style="top:700px;left:242px;" src="/dakar2026/en/static/_content/22-icon-5.png"/>

      <img class="abs halfScale 22-caption" style="top:526px;left:328px;" src="/dakar2026/en/static/_content/22-caption-2.png"/>
      <img class="abs halfScale 22-text" style="top:543px;left:328px;" src="/dakar2026/en/static/_content/22-text-2.png"/>

      <img class="abs halfScale 22-caption" style="top:594px;left:328px;" src="/dakar2026/en/static/_content/22-caption-3.png"/>
      <img class="abs halfScale 22-text" style="top:612px;left:328px;" src="/dakar2026/en/static/_content/22-text-3.png"/>

      <img class="abs halfScale 22-caption" style="top:661px;left:328px;" src="/dakar2026/en/static/_content/22-caption-4.png"/>
      <img class="abs halfScale 22-text" style="top:679px;left:328px;" src="/dakar2026/en/static/_content/22-text-4.png"/>

      <img class="abs halfScale 22-caption" style="top:728px;left:328px;" src="/dakar2026/en/static/_content/22-caption-5.png"/>
      <img class="abs halfScale 22-text" style="top:746px;left:328px;" src="/dakar2026/en/static/_content/22-text-5.png"/>

      <div class="abs" style="top:780px;left:294px;height:50px;width:180px;overflow:hidden;">
        <a href="https://www.olympics.com/athlete365/articles/dakar-2026/everything-you-need-to-know-about-athlete365-house-at-dakar-2026" target="_blank">
          <img class="abs halfScaleC 22-button" id="button" style="top:-9px;left:-30px;" src="/dakar2026/en/static/_content/22-button-1.png"/>
        </a>
      </div>

      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim.staggerFromTo(cOf("22-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("22-box"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .staggerFromTo(cOf("22-caption"), 0.7, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.9)
          .staggerFromTo(cOf("22-text"), 0.7, {opacity:0, y: 15}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 2.1)
          .staggerFromTo(cOf("22-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.2)
          .fromTo(cOf("22-button"), 0.8, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 3);
          setTimeout(function(){
            addPulse("button")
          }, 3000)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg22Anim.stop();
          removePulse("button")
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete365 House  Athlete365 House Everything you need to know about Athlete365 House – the centre of Youth Olympic Village life. Athlete365 House will play a key role in your time at Dakar 2026 as a space to learn, have fun and meet others. Here’s everything you can expect.  Learn Athlete365 House is the home of the Athlete Education Programme, which all athletes must complete during the Games.  FIND OUT MORE  Play  Have fun and compete against others on our arcade machines and video games.  Capture Commemorate your time at the Games in our photo kiosk.  Watch Sit down and catch all the live action on the big screens.  Meet Speak to members of the IOC Athletes’ Commission, Athlete Role Models and other IOC experts.  FIND OUT MORE LIFE IN THE VILLAGE  22"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 23-title" style="top:99px;left:20px;" src="/dakar2026/en/static/_content/23-title-1.png"/>
      <img class="abs halfScale 23-title" style="top:150px;left:20px;" src="/dakar2026/en/static/_content/23-title-2.png"/>
      <img class="abs halfScale 23-title" style="top:215px;left:20px;" src="/dakar2026/en/static/_content/23-sub-1.png"/>

      <img class="abs halfScale 23-text" style="top:427px;left:22px;" src="/dakar2026/en/static/_content/23-text-1.png"/>
      <img class="abs halfScaleC 23-icon" style="top:372px;left:109px;" src="/dakar2026/en/static/_content/23-icon-1.png"/>

      <img class="abs halfScale 23-text" style="top:520px;left:22px;" src="/dakar2026/en/static/_content/23-text-2.png"/>
      <img class="abs halfScaleC 23-icon" style="top:472px;left:155px;" src="/dakar2026/en/static/_content/23-icon-2.png"/>

      <img class="abs halfScale 23-text" style="top:630px;left:22px;" src="/dakar2026/en/static/_content/23-text-3.png"/>
      <img class="abs halfScaleC 23-icon" style="top:562px;left:225px;" src="/dakar2026/en/static/_content/23-icon-3.png"/>

      <img class="abs halfScale 23-text" style="top:713px;left:22px;" src="/dakar2026/en/static/_content/23-text-4.png"/>
      <img class="abs halfScaleC 23-icon" style="top:640px;left:315px;" src="/dakar2026/en/static/_content/23-icon-4.png"/>

      <img class="abs halfScale 23-text" style="top:789px;left:22px;" src="/dakar2026/en/static/_content/23-text-5.png"/>
      <img class="abs halfScaleC 23-icon" style="top:703px;left:419px;" src="/dakar2026/en/static/_content/23-icon-5.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim.staggerFromTo(cOf("23-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("23-text"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.6)
          .staggerFromTo(cOf("23-icon"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.7);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg23Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Eating and drinking  Eating and drinking Your food and beverage options have been carefully designed to offer you high-quality meals tailored to your dietary and nutritional requirements.  The Dining Hall will be open from 5 a.m. to 11 p.m. every day Specific menus available for breakfast (5 a.m. to 11 a.m.), lunch (11 a.m. to 6 p.m.) and dinner (6 p.m. to 11 p.m.)  Diverse selection including Senegalese and West African cuisine  Vegetarian, vegan and gluten-free options available  Water, local juices, and soft drinks from Coca-Cola available  LIFE IN THE VILLAGE  23"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>

      <img class="abs halfScale 24-title" style="top:126px;left:217px;" src="/dakar2026/en/static/_content/24-title-1.png"/>
      <img class="abs halfScale 24-title" style="top:208px;left:219px;" src="/dakar2026/en/static/_content/24-title-2.png"/>
      <img class="abs halfScale 24-title" style="top:288px;left:219px;" src="/dakar2026/en/static/_content/24-title-3.png"/>
      <img class="abs halfScale 24-title" style="top:381px;left:219px;" src="/dakar2026/en/static/_content/24-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(25);" style="top:480px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(26);" style="top:513px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(27);" style="top:546px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(28);" style="top:580px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(29);" style="top:614px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(30);" style="top:648px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(31);" style="top:680px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(32);" style="top:714px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(33);" style="top:746px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(34);" style="top:780px; left:216px; width:212px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(37);" style="top:814px; left:216px; width:212px; height:22px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax();
          pg24Anim.staggerFromTo(cOf("24-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg24Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme  Athlete Education Programme Helping you maximise your Youth Olympic Games experience. 25  Introduction  26  Overview  27  Learning courses  28  PinQuest  29  Integrity  30  Career support  31  Health and well-being  32  Digital and media  33  Olympic Impact  34  Athlete Role Models  37  Inside Sport Sessions  24"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 25-title" style="top:98px;left:21px;" src="/dakar2026/en/static/_content/25-title-1.png"/>
      <img class="abs halfScale 25-title" style="top:151px;left:23px;" src="/dakar2026/en/static/_content/25-title-2.png"/>
      <img class="abs halfScale 25-title" style="top:214px;left:20px;" src="/dakar2026/en/static/_content/25-sub-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();
          pg25Anim.staggerFromTo(cOf("25-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg25Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Introduction  What is the Athlete Education Programme? The Athlete Education Programme (AEP) is one of the main pillars of the Youth Olympic Games experience. The Youth Olympic Games provide a unique opportunity for you to compete on an international stage, but also to start developing new skills and experience off the field of play. The AEP is designed to equip all participating athletes with the  Athlete EDUCATION PROGRAMME  knowledge, skills and mindset needed to excel, both at the Games and beyond. If you're an entourage member such as a coach, physio, medical practitioner, nutritionist, family member or NOC staff, the programme will provide you  with the tools you need to lead your athletes to success on the international stage.  25"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 26-title" style="top:80px;left:21px;" src="/dakar2026/en/static/_content/26-sub-1.png"/>
      <img class="abs halfScale 26-title" style="top:98px;left:21px;" src="/dakar2026/en/static/_content/26-title-1.png"/>
      <img class="abs halfScale 26-title" style="top:163px;left:20px;" src="/dakar2026/en/static/_content/26-sub-2.png"/>

      <img class="abs halfScaleC 26-icon" style="top:452px;left:2px;" src="/dakar2026/en/static/_content/26-icon-1.png"/>
      <img class="abs halfScale 26-text" style="top:481px;left:89px;" src="/dakar2026/en/static/_content/26-text-1.png"/>
      <img class="abs halfScaleC 26-icon" style="top:548px;left:2px;" src="/dakar2026/en/static/_content/26-icon-2.png"/>
      <img class="abs halfScale 26-text" style="top:574px;left:89px;" src="/dakar2026/en/static/_content/26-text-2.png"/>
      <img class="abs halfScaleC 26-icon" style="top:656px;left:2px;" src="/dakar2026/en/static/_content/26-icon-3.png"/>
      <img class="abs halfScale 26-text" style="top:684px;left:89px;" src="/dakar2026/en/static/_content/26-text-3.png"/>
      <img class="abs halfScaleC 26-icon" style="top:740px;left:2px;" src="/dakar2026/en/static/_content/26-icon-4.png"/>
      <img class="abs halfScale 26-text" style="top:774px;left:89px;" src="/dakar2026/en/static/_content/26-text-4.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim.staggerFromTo(cOf("26-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("26-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.6)
          .staggerFromTo(cOf("26-text"), 0.7, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.7);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg26Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Athlete Education Programme: Overview  Contents  Athlete Education Programme:  Overview  The Athlete Education Programme (AEP) consists of multiple activities, both before and during the Games. Pre-Games  Before you travel to Dakar, please complete our Athlete365 Learning course, Mastering your Sporting Journey – available for athletes and entourage members.  During the Games  When you’re in Dakar, you are requested to set aside four hours (non-consecutive) to complete the various AEP activities, located at Athlete365 House. The AEP is delivered through four formats: Learning activities: Seven interactive activities teaching you about various important topics for your career and life ahead.  PinQuest: A mobile game that challenges you to complete the seven learning activities, boost your Olympic knowledge, and win exclusive Olympic prizes.  Athlete Role Models: Experienced Olympians and elite athletes who will be on-site throughout the Games to provide mentorship, learning and inspiration.  Inside Sport Sessions: An opportunity to learn from Athlete Role Models and other athletes on topics specific to your sport.  Athlete EDUCATION PROGRAMME  26"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 27-title" style="top:80px;left:21px;" src="/dakar2026/en/static/_content/27-sub-1.png"/>
      <img class="abs halfScale 27-title" style="top:98px;left:21px;" src="/dakar2026/en/static/_content/27-title-1.png"/>
      <img class="abs halfScale 27-title" style="top:152px;left:21px;" src="/dakar2026/en/static/_content/27-title-2.png"/>
      <img class="abs halfScale 27-title" style="top:214px;left:20px;" src="/dakar2026/en/static/_content/27-sub-2.png"/>

      <img class="abs halfScaleC 27-icon" style="top:440px;left:75px;" src="/dakar2026/en/static/_content/27-icon-1.png"/>
      <img class="abs halfScale 27-text" style="top:581px;left:125px;" src="/dakar2026/en/static/_content/27-subtext-1.png"/>
      <img class="abs halfScale 27-text" style="top:605px;left:39px;" src="/dakar2026/en/static/_content/27-text-1.png"/>

      <a href="https://www.olympics.com/athlete365/learning/mastering-your-sporting-journey-for-young-athletes" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 27-btn pointer" style="top:725px;left:24px;" src="/dakar2026/en/static/_content/27-button-1.png"/>
      </a>

      <img class="abs halfScale 27-line" style="top:522px;left:305px;" src="/dakar2026/en/static/_content/27-line-1.png"/>

      <img class="abs halfScaleC 27-icon" style="top:440px;left:370px;" src="/dakar2026/en/static/_content/27-icon-2.png"/>
      <img class="abs halfScale 27-text" style="top:581px;left:379px;" src="/dakar2026/en/static/_content/27-subtext-2.png"/>
      <img class="abs halfScale 27-text" style="top:605px;left:331px;" src="/dakar2026/en/static/_content/27-text-2.png"/>

      <a href="https://www.olympics.com/athlete365/learning/mastering-your-sporting-journey-for-athletes-entourage-members" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 27-btn pointer" style="top:725px;left:317px;" src="/dakar2026/en/static/_content/27-button-1.png"/>
      </a>
      
      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim.staggerFromTo(cOf("27-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("27-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.6)
          .staggerFromTo(cOf("27-text"), 0.7, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.8)
          .fromTo(cOf("27-line"), 0.7, {opacity:0, x: -20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.8);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg27Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Athlete Education Programme: Learning courses  Contents  Athlete Education Programme:  Mastering Your Sporting Journey Our learning course sets athletes and entourage members up for success at the Youth Olympic Games – and beyond. Ahead of Dakar 2026, you are asked to complete the Athlete365 Learning course, Mastering your Sporting Journey. Two bespoke courses have been created for both athletes and entourage members.  Athletes  Entourage members  If you are an athlete, this course will teach you how to build your mental fitness, protect yourself and others, and keep sport clean.  For entourage members – anyone supporting an athlete on their journey to the YOG – this course will teach you how to support your athlete’s mental health, foster a safe sporting environment and protect the integrity of sport.  The course is available in nine languages.  The course is available in six languages.  TAKE THE COURSE  Athlete EDUCATION PROGRAMME  TAKE THE COURSE  27"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 28-title" style="top:110px;left:20px;" src="/dakar2026/en/static/_content/28-title-1.png"/>
        <img class="abs halfScale 28-sub" style="top:232px;left:20px;" src="/dakar2026/en/static/_content/28-sub-1.png"/>

        <div class="addContentLink" style="top:83px;left:503px;width:64px;height:66px;">
          <a href="https://qrco.de/bcFFH9" target="_blank"></a>
        </div>

      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim.fromTo(cOf("28-title"), 0.8, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.8)
          .fromTo(cOf("28-sub"), 0.8, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg28Anim.stop();          
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Athlete Education Programme: PinQuest  Contents  28  Download PinQuest here  Your guide through the Athlete Education Programme – and chance to win exclusive Olympic prizes! PinQuest is a mobile game that will guide you through the in-person Athlete Education Programme learning activities. Complete the activities to win an exclusive pin collection and boost your Olympic knowledge for another special prize!  Step 1  Step 2  Step 3  Before you arrive at Athlete365 House to start the Athlete Education Programme, download the PinQuest app and register or sign in using your Olympic ID.  Use PinQuest to navigate the seven learning activities and validate your progress within the app.  Continue your PinQuest adventure by testing your Olympic knowledge.  Athlete EDUCATION PROGRAMME  When all activities are complete, head to the PinQuest desk to pick up your exclusive pin box.  If you accumulate 10,000 points, head to the desk for another special prize – an Athlete365 bucket hat!"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 29-title" style="top:80px;left:20px;" src="/dakar2026/en/static/_content/29-sub-1.png"/>
        <img class="abs halfScale 29-title" style="top:103px;left:20px;" src="/dakar2026/en/static/_content/29-title-1.png"/>
        <img class="abs halfScale 29-title" style="top:166px;left:20px;" src="/dakar2026/en/static/_content/29-sub-2.png"/>
        <img class="abs halfScaleC halfpulse animatedpulse 29-button-1" style="top:301px;left:170px;" src="/dakar2026/en/static/_content/29-button-1.png"/>
        
        <div class="abs pointer" onclick="Publish.goToPage(42);" style="top:371px;left:383px;width:116px;height:46px;border-radius:30px;">
          <img class="abs halfScaleC halfpulse animatedpulse 29-button-2" src="/dakar2026/en/static/_content/29-button-2.png"/>
        </div>

        <a class="abs" href="https://www.olympics.com/athlete365/articles/pcm/meet-your-believe-in-sport-ambassadors-for-dakar-2026" style="top:323px;left:254px;width:172px;height:42px;border-radius:30px;" target="_blank"></a>
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim.staggerFromTo(cOf("29-title"), 0.8, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg29Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Integrity  Athlete Education Programme:  Integrity  We all have a responsibility to protect clean sport. This learning activity will teach you about the prevention of competition manipulation and anti-doping.  29  Believe in Sport  Together for Clean Sport  Take part in an interactive game featuring various scenarios that will help you understand the Code of Conduct on Competition Manipulation.  Engage with representatives from the World Anti-Doping Agency (WADA) and the International Testing Agency (ITA) to learn about antidoping rules and the resources available to support you.  You will meet the Believe in Sport athlete ambassadors, hear real-life stories and have the chance to ask any questions.  Get to know the Believe in Sport ambassadors  You will have a choice of three interactive activities, including a simulation of the doping control process, and the chance to speak to current and retired athletes about clean sport.  Anti-doping at Dakar 2026  Athlete EDUCATION PROGRAMME"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 30-title" style="top:80px;left:20px;" src="/dakar2026/en/static/_content/30-sub-1.png"/>
        <img class="abs halfScale 30-title" style="top:100px;left:20px;" src="/dakar2026/en/static/_content/30-title-1.png"/>
        <img class="abs halfScale 30-title" style="top:163px;left:20px;" src="/dakar2026/en/static/_content/30-sub-2.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg30Anim = new TimelineMax();
          pg30Anim.staggerFromTo(cOf("30-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          }, 2000)
        }

        function onPageLeave() {
          pg30Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Career support  Athlete Education Programme:  Career support It’s important to prepare for a life beyond sport. This learning activity will help you discover new skills and the support programmes available from Olympic Solidarity. Athlete365 Career+ Unlock your Potential, supported by Allianz Collaborate with other athletes and entourage members to solve puzzles, uncover and leverage skills for life beyond sport, and learn how to balance your life on and off the field of play.  Athlete EDUCATION PROGRAMME  Olympic Solidarity Get involved in a game of snookball – a cross between snooker and football – to learn about Olympic Solidarity and the training and education opportunities available to you through your National Olympic Committee.  30"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 31-title" style="top:80px;left:20px;" src="/dakar2026/en/static/_content/30-sub-1.png"/>
        <img class="abs halfScale 31-title" style="top:103px;left:20px;" src="/dakar2026/en/static/_content/31-title-1.png"/>
        <img class="abs halfScale 31-title" style="top:166px;left:20px;" src="/dakar2026/en/static/_content/31-sub-2.png"/>
        <img class="abs halfScaleC halfpulse animatedpulse 31-button" style="top:727px;left:196px;" src="/dakar2026/en/static/_content/31-button-1.png"/>

        <div class="abs pointer" onclick="Publish.goToPage(39);" style="top:748px;left:258px;width:124px;height:43px;border-radius:30px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim.staggerFromTo(cOf("31-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg31Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Health and well-being  31  Athlete Education Programme:  Health and Well-being Your health and well-being matter, both on and off the field of play. This learning activity will help you build the skills to manage your physical and mental health and recognise concerning behaviours. Injury prevention  Meet experts who will show you practical exercises to help prevent injuries and perform at your best using the Get Set – Train Smarter app (more info on p46).  Mental health Take a moment to slow down, be mindful and discover simple ways to look after your mental well-being.  Mind, Body and Me  The Mind, Body and Me space is a welcoming area where you can take a break, learn something new and discover ways to support your health and well-being.  Safeguarding  Learn how to recognise healthy relationships, set personal boundaries and where to turn if something doesn't feel right. You can also speak to an IOC Safeguarding Officer if you need support.  Athlete EDUCATION PROGRAMME  How to seek help at Dakar 2026"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 32-title" style="top:493px;left:20px;" src="/dakar2026/en/static/_content/32-sub-1.png"/>
        <img class="abs halfScale 32-title" style="top:513px;left:20px;" src="/dakar2026/en/static/_content/32-title-1.png"/>
        <img class="abs halfScale 32-title" style="top:577px;left:20px;" src="/dakar2026/en/static/_content/32-sub-2.png"/>
    
        <div class="abs" style="top:653px;left:467px;height: 182px;width: 133px;overflow:hidden;">
          <img class="abs halfScale 32-box" style="top:0px;left:0px;" src="/dakar2026/en/static/_content/32-box-1.png"/>
          <img class="abs halfScaleC 32-button" id="button" style="top:126px;left:-47px;" src="/dakar2026/en/static/_content/32-button-1.png"/>
          <a href="https://www.olympics.com/athlete365/learning/building-a-winning-personal-brand" target="_blank">
            <div class="abs pointer" style="top:139px;left:10px;width:114px;height:29px;border-radius:30px;"></div>
          </a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim.staggerFromTo(cOf("32-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("32-box"), 0.6, {opacity:0, y: 100}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)
          .fromTo(cOf("32-button"), 0.8, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1.6);
          setTimeout(function(){
            addPulse("button")
          }, 3000)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg32Anim.stop();
          removePulse("button")
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Athlete Education Programme: Digital and media  Contents  32  Athlete Education Programme:  Digital and media Want to explore sports broadcasting and digital storytelling? This learning activity will take you behind the scenes of live television and help you create your own content. Broadcast Lab  Go behind the scenes with Olympic Broadcasting Services (OBS) as you get a hands-on experience of live television. Rotate between the different stations and  Athlete EDUCATION PROGRAMME  understand how each role contributes to a successful sports broadcast.  Creators Studio Presented by The Olympic Channel, this interactive hub will  allow you to explore the world of digital storytelling, enhance your understanding of Olympics.com and create your own engaging content.  Want to build your personal brand? Check out our Athlete365 Learning course.  TAKE THE COURSE"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 33-title" style="top:386px;left:20px;" src="/dakar2026/en/static/_content/33-sub-1.png"/>
        <img class="abs halfScale 33-title" style="top:406px;left:20px;" src="/dakar2026/en/static/_content/33-title-1.png"/>
        <img class="abs halfScale 33-title" style="top:458px;left:20px;" src="/dakar2026/en/static/_content/33-title-2.png"/>
        <img class="abs halfScale 33-title" style="top:523px;left:21px;" src="/dakar2026/en/static/_content/33-sub-2.png"/>
        
        <img class="abs halfScale 33-icon" style="top:710px;left:73px;" src="/dakar2026/en/static/_content/33-icon-1.png"/>
        <img class="abs halfScale 33-icon" style="top:710px;left:269px;" src="/dakar2026/en/static/_content/33-icon-2.png"/>
        <img class="abs halfScale 33-icon" style="top:710px;left:464px;" src="/dakar2026/en/static/_content/33-icon-3.png"/>
        
        <img class="abs halfScale 33-text" style="top:772px;left:46px;" src="/dakar2026/en/static/_content/33-text-1.png"/>
        <img class="abs halfScale 33-text" style="top:772px;left:250px;" src="/dakar2026/en/static/_content/33-text-2.png"/>
        <img class="abs halfScale 33-text" style="top:772px;left:435px;" src="/dakar2026/en/static/_content/33-text-3.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();
          pg33Anim.staggerFromTo(cOf("33-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("33-icon"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)
          .staggerFromTo(cOf("33-text"), 1, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1.7);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg33Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Education Programme: Olympic Impact  Athlete Education Programme:  Olympic Impact presented by IOC Young Leaders Did you know that the IOC uses sport to create positive change in society? This learning activity will help you understand how sport can impact the wider world and how you can be a part of this effort. Meet the IOC Young Leaders, a group of inspiring young people supported by the IOC to leverage the power of sport in their communities. They will guide you through a series of interactive activities that will demonstrate how we can use sport to:  Improve health and well-being  Athlete EDUCATION PROGRAMME  Increase access to education  Build more inclusive communities  33"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 34-title" style="top:98px;left:20px;" src="/dakar2026/en/static/_content/34-title-1.png"/>
        <img class="abs halfScale 34-sub" style="top:161px;left:20px;" src="/dakar2026/en/static/_content/34-sub-1.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim.fromTo(cOf("34-title"), 1, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("34-sub"), 1, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg34Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete Role Models  Athlete Role Models A crucial part of the Youth Olympic Games experience, Athlete Role Models will be on site throughout Dakar 2026 to offer first-hand mentorship and education. What are Athlete Role Models?  What will they be doing?  These experienced Olympians and elite athletes have been nominated by their International Federations to pass on their knowledge to you, the next generation.  • Athlete Education Programme learning activities • Inside Sport Sessions • Competitions and training • Victory ceremonies  At Dakar 2026, there will be at least one Athlete Role Model for each of the 25 competition and 10 engagement sports.  Meet your Athlete Role Models on the next page.  Athlete Role Models have been present at the Youth Olympic Games since the very first edition at Singapore 2010.  Athlete EDUCATION PROGRAMME  During Dakar 2026, each Athlete Role Model will be on site for a designated period of time to participate in:  34"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 35-title" style="top:98px;left:20px;" src="/dakar2026/en/static/_content/35-title-1.png"/>
        <img class="abs halfScale 35-title" style="top:150px;left:20px;" src="/dakar2026/en/static/_content/35-title-2.png"/>
        
        <img class="abs halfScale 35-rolemodel" style="top:239px;left:21px;" src="/dakar2026/en/static/_content/35-rolemodel-1.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:239px;left:140px;" src="/dakar2026/en/static/_content/35-rolemodel-2.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:239px;left:260px;" src="/dakar2026/en/static/_content/35-rolemodel-3.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:239px;left:379px;" src="/dakar2026/en/static/_content/35-rolemodel-4.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:239px;left:499px;" src="/dakar2026/en/static/_content/35-rolemodel-5.png"/>
        
        <img class="abs halfScale 35-rolemodel" style="top:387px;left:21px;" src="/dakar2026/en/static/_content/35-rolemodel-6.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:387px;left:140px;" src="/dakar2026/en/static/_content/35-rolemodel-7.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:387px;left:260px;" src="/dakar2026/en/static/_content/35-rolemodel-8.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:387px;left:379px;" src="/dakar2026/en/static/_content/35-rolemodel-9.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:387px;left:499px;" src="/dakar2026/en/static/_content/35-rolemodel-10.png"/>
        
        <img class="abs halfScale 35-rolemodel" style="top:537px;left:20px;" src="/dakar2026/en/static/_content/35-rolemodel-11.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:537px;left:140px;" src="/dakar2026/en/static/_content/35-rolemodel-12.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:537px;left:260px;" src="/dakar2026/en/static/_content/35-rolemodel-13.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:537px;left:374px;" src="/dakar2026/en/static/_content/35-rolemodel-14.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:537px;left:499px;" src="/dakar2026/en/static/_content/35-rolemodel-15.png"/>
        
        <img class="abs halfScale 35-rolemodel" style="top:684px;left:20px;" src="/dakar2026/en/static/_content/35-rolemodel-16.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:684px;left:140px;" src="/dakar2026/en/static/_content/35-rolemodel-17.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:684px;left:260px;" src="/dakar2026/en/static/_content/35-rolemodel-18.png"/>
        <img class="abs halfScale 35-rolemodel" style="top:684px;left:379px;" src="/dakar2026/en/static/_content/35-rolemodel-19.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();
          pg35Anim.staggerFromTo(cOf("35-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 0.8)
          .staggerFromTo(cOf("35-rolemodel"), 0.5, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.2);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg35Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Athlete Role Models  Contents  35  Meet your Athlete Role Models  Clarisse Agbegnenou  Omar Al Marzooqi  Stéphane Badji  Christopher Bak  Lisa Barbelin  France | Judo  United Arab Emirates | Equestrian  Senegal | Football  United States of America | Rowing  France | Archery  Asunción Batista  Rémy Bedi  Yves Bourhis  Jean-Pierre Bourhis  Darcy Bourne  Spain | Beach Handball  France | Golf  Senegal | Canoe Slalom  Senegal | Canoe Slalom  Great Britain | Hockey  Douglas Brose  Sheila Chajira  Doaa Elghobashy  Jomana Elsafy  Ruth Gbagbi  Brazil | Karate  Kenya | Rugby Sevens  Egypt | Beach Volleyball  Egypt | Shooting  Côte d'Ivoire | Taekwondo  Sonja Greinacher  Yasser Hefny  Zohra Nora Kehli  Khadija Krimi  Germany | 3x3 Basketball  Egypt | Modern Pentathlon  Algeria | Fencing  Tunisia | Rowing  Athlete EDUCATION PROGRAMME"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
        <img class="abs halfScale 36-title" style="top:98px;left:20px;" src="/dakar2026/en/static/_content/36-title-1.png"/>
        <img class="abs halfScale 36-title" style="top:150px;left:20px;" src="/dakar2026/en/static/_content/36-title-2.png"/>
        
        <img class="abs halfScale 36-rolemodel" style="top:239px;left:21px;" src="/dakar2026/en/static/_content/36-rolemodel-1.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:239px;left:140px;" src="/dakar2026/en/static/_content/36-rolemodel-2.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:239px;left:260px;" src="/dakar2026/en/static/_content/36-rolemodel-3.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:239px;left:379px;" src="/dakar2026/en/static/_content/36-rolemodel-4.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:239px;left:499px;" src="/dakar2026/en/static/_content/36-rolemodel-5.png"/>
        
        <img class="abs halfScale 36-rolemodel" style="top:387px;left:21px;" src="/dakar2026/en/static/_content/36-rolemodel-6.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:387px;left:140px;" src="/dakar2026/en/static/_content/36-rolemodel-7.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:387px;left:260px;" src="/dakar2026/en/static/_content/36-rolemodel-8.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:387px;left:379px;" src="/dakar2026/en/static/_content/36-rolemodel-9.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:387px;left:499px;" src="/dakar2026/en/static/_content/36-rolemodel-10.png"/>
        
        <img class="abs halfScale 36-rolemodel" style="top:537px;left:20px;" src="/dakar2026/en/static/_content/36-rolemodel-11.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:537px;left:140px;" src="/dakar2026/en/static/_content/36-rolemodel-12.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:537px;left:260px;" src="/dakar2026/en/static/_content/36-rolemodel-13.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:537px;left:374px;" src="/dakar2026/en/static/_content/36-rolemodel-14.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:537px;left:499px;" src="/dakar2026/en/static/_content/36-rolemodel-15.png"/>
        
        <img class="abs halfScale 36-rolemodel" style="top:684px;left:20px;" src="/dakar2026/en/static/_content/36-rolemodel-16.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:684px;left:140px;" src="/dakar2026/en/static/_content/36-rolemodel-17.png"/>
        <img class="abs halfScale 36-rolemodel" style="top:684px;left:260px;" src="/dakar2026/en/static/_content/36-rolemodel-18.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax();
          pg36Anim.staggerFromTo(cOf("36-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 0.8)
          .staggerFromTo(cOf("36-rolemodel"), 0.5, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.2);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg36Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Athlete Role Models  Contents  36  Meet your Athlete Role Models  Xiaoxiao Lai  Yannick Languina  Rayssa Leal  Vincent Luis  Jamila Lunkuse  People's Republic of China Wushu  Senegal | Tennis  Brazil | Skateboarding  France | Triathlon  Uganda | Swimming  Dina Meshref  Halimah Nakaayi  Kaylia Nemour  Blessing Oborududu  Hiroto Ono (HIRO10)  Egypt | Table Tennis  Uganda | Athletics  Algeria | Artistic Gymnastics  Nigeria | Wrestling  Japan | Breaking  Forrester Osei  Ayako Rokkaku  Elnaz Rekabi  Edmond Sanka  Combe Seck  Ghana | Weightlifting  Japan | Baseball/Softball  Iran | Climbing  Senegal | Canoe Sprint, Para Canoe  Senegal | Canoe Sprint  Richard Torrez Jr.  Maja Włoszczowska  Siwei Zheng  United States of America | Boxing  Poland | Cycling Mountain Bike  People's Republic of China Badminton  Athlete EDUCATION PROGRAMME"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 37-title" style="top:326px;left:20px;" src="/dakar2026/en/static/_content/37-title-1.png"/>
      <img class="abs halfScale 37-title" style="top:439px;left:20px;" src="/dakar2026/en/static/_content/37-sub-1.png"/>
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax();
          pg37Anim.staggerFromTo(cOf("37-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg37Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Inside Sport Sessions  Inside Sport Sessions Come together with other athletes from your sport to learn sport-specific lessons and engage with your Athlete Role Models. At some point during Dakar 2026, you will have the chance to attend an Inside Sport Session dedicated to your discipline. Led by International Federations (IFs), these sessions provide an opportunity to: • Meet others who compete in the same sport as you • Learn more about your sport from elite athletes and IF staff •M  eet your Athlete Role Model(s) and ask them questions The date and time of your session will be communicated to you before the Games.  Athlete EDUCATION PROGRAMME  37"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 38-title" style="top:206px;left:218px;" src="/dakar2026/en/static/_content/38-title-1.png"/>
      <img class="abs halfScale 38-title" style="top:285px;left:216px;" src="/dakar2026/en/static/_content/38-title-2.png"/>
      <img class="abs halfScale 38-title" style="top:381px;left:219px;" src="/dakar2026/en/static/_content/38-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(39);" style="top:480px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(40);" style="top:513px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(41);" style="top:546px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(42);" style="top:580px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(43);" style="top:614px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(44);" style="top:648px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(45);" style="top:680px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(46);" style="top:714px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(47);" style="top:746px; left:216px; width:218px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(48);" style="top:780px; left:216px; width:218px; height:22px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg38Anim = new TimelineMax();
          pg38Anim.staggerFromTo(cOf("38-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg38Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Need to know  NEED TO KNOW Essential information for a stress-free Games. 39  How to seek help  40 Online abuse protection 41  Mindfulness app  42  Anti-doping  43  Athlete expression  44  Content guidelines  45  How to access tickets  46  Get Set – Train Smarter  47  Sustainability  48  Departures  38"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 39-title" style="top:97px;left:22px;" src="/dakar2026/en/static/_content/39-title-1.png"/>
      <img class="abs halfScale 39-title" style="top:150px;left:21px;" src="/dakar2026/en/static/_content/39-title-2.png"/>
      <img class="abs halfScale 39-title" style="top:213px;left:21px;" src="/dakar2026/en/static/_content/39-sub-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 39-btn pointer" style="top:225px;left:264px;" src="/dakar2026/en/static/_content/39-button-1.png"/>
      <img class="abs halfScaleC halfpulse animatedpulse 39-btn pointer" style="top:666px;left:357px;" src="/dakar2026/en/static/_content/39-button-2.png"/>

      <a class="abs" href="https://ioc.integrityline.org/" style="top:686px;left:416px;width:120px;height:41px;border-radius:30px;" target="_blank"></a>
      <a class="abs" href="mailto:safeguardingofficer@olympic.org" style="top:245px;left:371px;width:212px;height:42px;border-radius:30px;" target="_blank"></a>
      
      `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax();
          pg39Anim.staggerFromTo(cOf("39-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg39Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | How to seek help  How to seek help Whether you find yourself struggling or have seen something that doesn't feel right, here's how to find support. No pressure, no judgement – just someone who’s got your back.  39  IOC Safeguarding Officers:  Whether you need support, have a question or simply want to talk to someone, head to the Mind, Body and Me space at Athlete365 House to speak to a trained IOC Safeguarding Officer. They are there for you throughout the Games. You can also reach out to them via email.  Email safeguardingofficer@olympic.org  Emergency services:  In case of an emergency, dial +221 followed by: POLICE: 17 FIRE SERVICE: 18 AMBULANCE: 1515  IOC Integrity Hotline: If you’re being subject to harassment/abuse, spot something that doesn’t feel right, or want to report suspected competition manipulation, file an online report. You can remain anonymous if you wish.  CONTACT THE IOC INTEGRITY HOTLINE  Need to know"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 40-title" style="top:97px;left:22px;" src="/dakar2026/en/static/_content/40-title-1.png"/>
      <img class="abs halfScale 40-title" style="top:150px;left:21px;" src="/dakar2026/en/static/_content/40-title-2.png"/>
      <img class="abs halfScale 40-title" style="top:213px;left:21px;" src="/dakar2026/en/static/_content/40-sub-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim.staggerFromTo(cOf("40-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg40Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Online abuse protection  Contents  40  Protecting you from abuse on social media A monitoring system powered by artificial intelligence (AI) is in place to help protect athletes from online abuse on social media during the Games.  How does the service work?  The system uses AI to identify abusive comments, images or emojis directed at athletes on public-facing accounts and flag them for swift action by the platform.  Across two Olympic Games, the service has:  Analysed 4.3 million posts and comments directed at more  than 26,000 athletes' and officials' social media handles in real time   Flagged ~242,000 posts and comments as potentially abusive ~24,700 posts and comments as abusive and reported  Verified these to the platforms  How effective is the service?   Detected ~18,900 unique accounts sending abusive messages  Who is covered? When is the service in place?  Need to know  All competing athletes are automatically covered. You can opt out at any time by sending an email to safeguardingofficer@olympic.org.  The service will start on 29 October 2026 and end on 15 November 2026."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 41-title" style="top:97px;left:22px;" src="/dakar2026/en/static/_content/41-title-1.png"/>
      <img class="abs halfScale 41-title" style="top:150px;left:21px;" src="/dakar2026/en/static/_content/41-title-2.png"/>
      <img class="abs halfScale 41-title" style="top:213px;left:21px;" src="/dakar2026/en/static/_content/41-sub-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 41-btn pointer" style="top:550px;left:-77px;" src="/dakar2026/en/static/_content/41-button-1.png"/>

      <a class="abs" href="https://www.olympics.com/athlete365/offers/mental-health/free-mindfulness-app-subscription" style="top:564px;left:18px;width:195px;height:30px;border-radius:30px;" target="_blank"></a>

      
      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax();
          pg41Anim.staggerFromTo(cOf("41-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg41Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Mindfulness app  Claim your free mindfulness app subscription Want to improve your mental fitness or learn new ways to deal with stressful situations? Get a free one-year subscription to a leading mindfulness app – on us. As an athlete, you know that physical fitness is essential to success, but what about your mental game? Are you training your mind just as hard as you train your body? Mindfulness is the powerful practice of paying attention to the present moment and is proven to help improve your mental health and performance. We’re offering all Athlete365 members a free one-year premium subscription to a leading mindfulness app, helping you stay on top of your game at Dakar 2026 and beyond.  claim your subscription  Need to know  41"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 42-title" style="top:97px;left:21px;" src="/dakar2026/en/static/_content/42-title-1.png"/>
      <img class="abs halfScale 42-title" style="top:150px;left:21px;" src="/dakar2026/en/static/_content/42-title-2.png"/>
      <img class="abs halfScale 42-title" style="top:213px;left:21px;" src="/dakar2026/en/static/_content/42-sub-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 42-btn pointer" style="top:317px;left:-68px;" src="/dakar2026/en/static/_content/42-button-1.png"/>
      <img class="abs halfScaleC halfpulse animatedpulse 42-btn pointer" style="top:498px;left:267px;" src="/dakar2026/en/static/_content/42-button-2.png"/>
      <img class="abs halfScaleC halfpulse animatedpulse 42-btn pointer" style="top:336px;left:254px;" src="/dakar2026/en/static/_content/42-button-2.png"/>

      <a class="abs" href="https://stillmed.olympics.com/media/Documents/Olympic-Games/Youth-Olympic-Games/Dakar-2026/IOC-Anti-Doping-Rules-applicable-to-the-4th-Summer-Youth-Olympic-Games-Dakar-2026.pdf" style="top:331px;left:19px;width:174px;height:33px;border-radius:30px;" target="_blank"></a>
      <a class="abs" href="https://ita.sport/an-athlete-guide-for-clean-sport-at-dakar-2026-2/" style="top:351px;left:319px;width:134px;height:32px;border-radius:30px;" target="_blank"></a>
      <a class="abs" href="https://ita.sport/resource/a-guide-to-doping-control-for-athletes-who-are-minors-2/" style="top:513px;left:332px;width:134px;height:32px;border-radius:30px;" target="_blank"></a>

      `,
      "script": `
        function onPageEnter() {
          pg42Anim = new TimelineMax();
          pg42Anim.staggerFromTo(cOf("42-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg42Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Anti-doping  42  Anti-doping rules and resources Every athlete and entourage member attending the Youth Olympic Games must comply with the IOC’s anti-doping rules. To protect yourself and your place at the Games, it is essential that you understand the anti-doping rules that are in place.  FULL ANTI-DOPING RULES  Before you arrive in Dakar, explore the Athlete Guide for Clean Sport at Dakar 2026 for practical advice, key anti-doping information and resources to help you compete clean and confidently.  READ THE GUIDE New to doping control? We've got you covered. Download and share this practical guide to learn what to expect during the doping control process, including the modifications in place for athletes under 18.  READ THE GUIDE  Need to know"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 43-title" style="top:391px;left:21px;" src="/dakar2026/en/static/_content/43-title-1.png"/>
      <img class="abs halfScale 43-title" style="top:455px;left:21px;" src="/dakar2026/en/static/_content/43-sub-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 43-btn pointer" style="top:751px;left:-58px;" src="/dakar2026/en/static/_content/43-button-1.png"/>

      <a class="abs" href="https://www.olympics.com/athlete365/articles/athlete-expression/athlete-expression-guidelines-for-dakar-2026" style="top:766px;left:22px;width:160px;height:33px;border-radius:30px;" target="_blank"></a>

      `,
      "script": `
        function onPageEnter() {
          pg43Anim = new TimelineMax();
          pg43Anim.staggerFromTo(cOf("43-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg43Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Athlete expression  Athlete Expression The Athlete Expression Guidelines outline the opportunities you have to express your views at the Games while respecting others. Built on the results of our consultation with more than 3,500 athletes, the Athlete Expression Guidelines aim to ensure that: • Sport at the Youth Olympic Games is neutral and separate from political, religious or any other type of interference • The focus on the field of play during competitions and official ceremonies is on celebrating athletes’ performances • The Youth Olympic Village provides respectful conditions for all athletes to live together  READ THE GUIDELINES  Need to know  43"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 44-title" style="top:99px;left:21px;" src="/dakar2026/en/static/_content/44-title-1.png"/>
      <img class="abs halfScale 44-title" style="top:150px;left:21px;" src="/dakar2026/en/static/_content/44-title-2.png"/>
      <img class="abs halfScale 44-title" style="top:212px;left:21px;" src="/dakar2026/en/static/_content/44-sub-1.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg44Anim = new TimelineMax();
          pg44Anim.staggerFromTo(cOf("44-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg44Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Contents  Get Ready Pack: Dakar 2026 | Content guidelines  Content guidelines You are encouraged to share your Youth Olympic Games experience with your family, friends and supporters. The IOC content guidelines set out exactly where and when you are able to capture content and what you can share on your social media accounts or other channels. You will need to follow the guidelines from 27 October to 15 November 2026.  Need to know  Why do these guidelines exist? The guidelines allow you to share your experience at the Games while protecting the rights of IOC Media Rights-Holders. Guidelines apply to both athletes and other accredited individuals, and will be available soon on Athlete365.  44"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 45-title" style="top:99px;left:21px;" src="/dakar2026/en/static/_content/45-title-1.png"/>
      <img class="abs halfScale 45-title" style="top:161px;left:21px;" src="/dakar2026/en/static/_content/45-sub-1.png"/>

      <img class="abs halfScale 45-bottom-bar" style="top:835px;left:0px;" src="/dakar2026/en/static/_content/45-bottom-bar-1.png"/>

      <div class="abs" style="top:653px;left:54px;height: 182px;width: 133px;overflow:hidden;">
        <img class="abs halfScale 45-box" style="top:43px;left:0px;" src="/dakar2026/en/static/_content/45-box-1.png"/>
        <img class="abs halfScaleC 45-button" id="button" style="top:121px;left:-38px;" src="/dakar2026/en/static/_content/45-button-1.png"/>
        <a href="https://tickets.dakar2026.org/en" target="_blank">
          <div class="abs pointer" style="top:139px;left:10px;width:114px;height:29px;border-radius:30px;"></div>
        </a>
      </div>

      `,
      "script": `
        function onPageEnter() {
          pg45Anim = new TimelineMax();
          pg45Anim.staggerFromTo(cOf("45-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("45-box"), 0.6, {opacity:0, y: 100}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)
          .fromTo(cOf("45-button"), 0.8, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1.6);
          setTimeout(function(){
            addPulse("button")
          }, 3000)

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg45Anim.stop();
          removePulse("button")
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | How to access tickets  Contents  45  How to access tickets Want to secure tickets for yourself and your loved ones? Here are your ticketing options. Tickets for family and friends  Opportunities for athletes  The Athletes’ Friends and Family Ticketing Programme guarantees you the chance to buy two tickets per session in which you are competing. This ensures that your loved ones can be there to support you if they are in Dakar.  Under the Same Discipline and Different Discipline Athletes programmes, you are able to attend any sporting session during the Games for free, using your accreditation.  Want to buy extra tickets?  Register now to access general ticket sales.  GET TICKETS Need to know  Note that you must be accompanied by a team official and access is on a first-come, first-served basis. Speak to your NOC for more information."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 46-title" style="top:202px;left:20px;" src="/dakar2026/en/static/_content/46-title-1.png"/>
      <img class="abs halfScale 46-title" style="top:266px;left:20px;" src="/dakar2026/en/static/_content/46-sub-1.png"/>

      <div class="addContentLink" style="top:81px;left:20px;width:42px;height:42px;">
        <a href="https://play.google.com/store/apps/details?id=org.olympic.app.getset&hl=en_GB" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top:81px;left:176px;width:42px;height:42px;">
        <a href="https://apps.apple.com/gb/app/get-set-train-smarter/id894609112" target="_blank"></a>
      </div>

      `,
      "script": `
        function onPageEnter() {
          pg46Anim = new TimelineMax();
          pg46Anim.staggerFromTo(cOf("46-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg46Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Get Set – Train Smarter  Contents  Google Play Store  App Store  Get Set – Train Smarter The Get Set – Train Smarter app helps incorporate injury prevention into your exercise routines using scientifically proven methods – allowing you to perform at your best and stay injury free when you need it the most. Prevent injuries with effective and evidence-based workout routines Exercises included for 55 sports Target the area you want to work on  Get Set is available in 11 languages: English, French, Spanish, Russian, German, Norwegian, Chinese, Korean, Finnish, Italian and Slovenian.  Need to know  46"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 47-title" style="top:99px;left:20px;" src="/dakar2026/en/static/_content/47-title-1.png"/>
      <img class="abs halfScale 47-title" style="top:161px;left:20px;" src="/dakar2026/en/static/_content/47-sub-1.png"/>

      <img class="abs halfScale 47-box" style="top:220px;left:20px;" src="/dakar2026/en/static/_content/47-box-1.png"/>
      <img class="abs halfScale 47-subtext" style="top:249px;left:42px;" src="/dakar2026/en/static/_content/47-subtext-1.png"/>
      <img class="abs halfScaleC 47-icon" style="top:294px;left:7px;" src="/dakar2026/en/static/_content/47-icon-1.png"/>
      <img class="abs halfScale 47-text" style="top:326px;left:96px;" src="/dakar2026/en/static/_content/47-text-1.png"/>
      <img class="abs halfScaleC 47-icon" style="top:374px;left:7px;" src="/dakar2026/en/static/_content/47-icon-2.png"/>
      <img class="abs halfScale 47-text" style="top:416px;left:96px;" src="/dakar2026/en/static/_content/47-text-2.png"/>
      <img class="abs halfScaleC 47-icon" style="top:457px;left:7px;" src="/dakar2026/en/static/_content/47-icon-3.png"/>
      <img class="abs halfScale 47-text" style="top:488px;left:96px;" src="/dakar2026/en/static/_content/47-text-3.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 47-btn pointer" style="top:502px;left:406px;" src="/dakar2026/en/static/_content/47-button-1.png"/>
      <a class="abs" href="https://stillmed.olympics.com/media/Documents/Beyond-the-Games/Sustainability/Essentials/How-to-be-a-sustainable-champion-guide.pdf" style="top:517px;left:465px;width:124px;height:32px;border-radius:30px;" target="_blank"></a>

      <img class="abs halfScale 47-subtext-2" style="top:594px;left:161px;" src="/dakar2026/en/static/_content/47-subtext-2.png"/>
      <img class="abs halfScaleC 47-icon-2" style="top:608px;left:-5px;" src="/dakar2026/en/static/_content/47-icon-4.png"/>
      <img class="abs halfScale 47-text-2" style="top:726px;left:28px;" src="/dakar2026/en/static/_content/47-text-4.png"/>
      <img class="abs halfScaleC 47-icon-2" style="top:608px;left:117px;" src="/dakar2026/en/static/_content/47-icon-5.png"/>
      <img class="abs halfScale 47-text-2" style="top:726px;left:133px;" src="/dakar2026/en/static/_content/47-text-5.png"/>
      <img class="abs halfScaleC 47-icon-2" style="top:608px;left:239px;" src="/dakar2026/en/static/_content/47-icon-6.png"/>
      <img class="abs halfScale 47-text-2" style="top:726px;left:254px;" src="/dakar2026/en/static/_content/47-text-6.png"/>
      <img class="abs halfScaleC 47-icon-2" style="top:608px;left:361px;" src="/dakar2026/en/static/_content/47-icon-7.png"/>
      <img class="abs halfScale 47-text-2" style="top:726px;left:392px;" src="/dakar2026/en/static/_content/47-text-7.png"/>
      <img class="abs halfScaleC 47-icon-2" style="top:608px;left:483px;" src="/dakar2026/en/static/_content/47-icon-8.png"/>
      <img class="abs halfScale 47-text-2" style="top:726px;left:503px;" src="/dakar2026/en/static/_content/47-text-8.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg47Anim = new TimelineMax();
          pg47Anim.staggerFromTo(cOf("47-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("47-box"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
          .fromTo(cOf("47-subtext"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .staggerFromTo(cOf("47-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.8)
          .staggerFromTo(cOf("47-text"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.9)

          .fromTo(cOf("47-subtext-2"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
          .staggerFromTo(cOf("47-icon-2"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.4)
          .staggerFromTo(cOf("47-text-2"), 0.8, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 2.6);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg47Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Sustainability  Contents  47  Sustainability at the Games As athletes, you have a key role to play in ensuring Dakar 2026 leaves a positive legacy for the local community and environment.  Sustainability objectives: Reduce waste and promote circular economy  Protect the natural environment Learn how you can be a sustainable champion with our guide.  Use environmentally and socially conscious products and services  FIND OUT MORE  How can athletes contribute?  Drink with less impact: Use a reusable water bottle  Need to know  Two bins, Eat local, zero excuses: feel global: Follow waste-sorting Opt for low carbon instructions to and more sustainable maximise recycling food options  Feed yourself, not the bin: Cut food waste by taking only what you need  Don’t need, don’t take: Refuse any unnecessary goods"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <img class="abs halfScale 48-title" style="top:97px;left:21px;" src="/dakar2026/en/static/_content/48-title-1.png"/>
      <img class="abs halfScale 48-title" style="top:160px;left:21px;" src="/dakar2026/en/static/_content/48-sub-1.png"/>
      
      <img class="abs halfScaleC 48-icon" style="top:293px;left:-4px;" src="/dakar2026/en/static/_content/48-icon-1.png"/>
      <img class="abs halfScaleC 48-icon" style="top:388px;left:-4px;" src="/dakar2026/en/static/_content/48-icon-2.png"/>
      <img class="abs halfScaleC 48-icon" style="top:484px;left:-4px;" src="/dakar2026/en/static/_content/48-icon-3.png"/>
      
      `,
      "script": `
        function onPageEnter() {
          pg48Anim = new TimelineMax();
          pg48Anim.staggerFromTo(cOf("48-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("48-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg48Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Get Ready Pack: Dakar 2026 | Departures  Contents  Departures What to expect when heading home after the Games.  On the day of your departure, your NOC will take you to the transport zone, where you will board a bus for the airport.  At the airport, you will be guided through check-in, security and immigration.  Finally, you will board your flight and head home from Dakar 2026.  From all of us at Athlete365, we hope you have a smooth journey and return home with special memories from your Youth Olympic Games experience!  Need to know  48"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" onclick="Publish.goToPage(2);" style="top:12px; left:20px; width:48px; height:10px;"></div>
      
      <div class="addContentLink" style="top:753px;left:500px;width:32px;height:30px">
        <a href="https://www.facebook.com/Athlete365/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:753px;left:538px;width:32px;height:30px">
        <a href="https://www.linkedin.com/showcase/athlete365/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:792px;left:500px;width:32px;height:30px">
        <a href="https://x.com/Athlete365" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:792px;left:538px;width:32px;height:30px">
        <a href="https://www.instagram.com/athlete365/" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top:833px;left:469px;width:134px;height:19px">
        <a href="https://www.olympics.com/athlete365" target="_blank"></a>
      </div>

      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "FOLLOW US olympics.com/athlete365"
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }

      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }

      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'addContentLink'
        })
      }

      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'addContentLinkThree'
        })
      }

      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }

      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }

      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function addPulse(id) {
        var element = document.getElementById(id)
        element.classList.add("halfpulse")
        element.classList.add("animatedpulse")
      }
      
      function removePulse(id) {
        var element = document.getElementById(id)
        element.classList.remove("halfpulse")
        element.classList.remove("animatedpulse")
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function animateNumbers(klass, delay = 1, stagger = 0.3) {
        numbers = cOf(klass)

        setTimeout(function() {
          for (let i = 0; i < numbers.length; i++) {
            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])
          }
        }, delay * 1000)
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function individualGallery(index) {
        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }



// WEBPACK FOOTER //
// ./src/document.js